/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class Enums {
    public static toString<T>(names: Map<T, string>, value: T) {
        if (names.has(value)) return names.get(value)!;
        else return 'UNDEFINED';
    }

    public static toStringArray<T>(names: Map<T, string>, values: T[]) {
        return values.map(v => this.toString(names, v));
    }

    public static fromString<T>(names: Map<T, string>, value: string): T | undefined {
        const e = Array.from(names).find(([k, v]) => v == value);

        return e ? e[0] : undefined;
    }

    public static findMeasurement(measurementId: number) {
        const e = Array.from(Enums.MeasurementId).find(([k, v]) => k == measurementId);
        return e ? e[0] : undefined;
    }

    public static API_STATUS = new Map<Mri.DisplayApi.API_STATUS, string>([
        [Mri.DisplayApi.API_STATUS.API_SUCCESS, 'No Error Dectected'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SELECT, 'Socket Select Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SOCKET_WRITE, 'Socket Write Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SOCKET_READ, 'Socket Read Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SOCKET_READ_TIMEOUT, 'Socket Read Timeout Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_REQUEST_SIZE, 'Invalid Request Size'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_REQUEST_TYPE, 'Invalid Request Type'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_REPLY_SIZE, 'Invalid Reply Size'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_MEMORY_MAP, 'I2C Memory Map Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_ARBRITRATION_LOSS, 'I2C Arbritration Loss Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_MASTER_XFER, 'I2C Master Bus Busy Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_BUS_ERROR, 'I2C Invalid Byte Count Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_MASTER_BUS_BUSY, 'I2C Invalid Bus Num Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_INVALID_BYTE_COUNT, 'I4C Spi Interface Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_INVALID_BUS_NUM, 'I2C Max Requests Queued Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_I2C_SPI_INTERFACE, 'I2C Queue Timeout Error'],
        [Mri.DisplayApi.API_STATUS.I2C_ERROR_I2C_MAX_REQUESTS_QUEUED, 'Mismatched Reply Error'],
        [Mri.DisplayApi.API_STATUS.I2C_ERROR_I2C_QUEUE_TIMEOUT, 'Invalid Parameter Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_MISMATCHED_REPLY, 'Flash Write Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_PARAM, 'Memory Alloc Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FLASH_WRITE, 'Receiver Timeout Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_MEMORY_ALLOC, 'No Available Bind Addresses'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_RECEIVER_TIMEOUT, 'File Open Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_NO_AVAIL_BIND_ADDR, 'File Read Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_OPEN, 'File Write Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_READ, 'File CRC Checksum Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_WRITE, 'File Upload Sequence Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_CRC, 'Invalid Upload File Name Or Size Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_UPLOAD_SEQ, 'File Upload Sequence Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_UPLOAD_FILE, 'Invalid Upload File Name Or Size Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_BIND_DUPLICATE_IPADDR, 'Requested Bind With Duplicate IP Addresses Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FLASH_UPDATE_BUSY, 'Requested Flash Update When Busy Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_THREAD_CREATE, 'Thread create error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_ENABLE_WEP_WHEN_UNBOUND, 'Trying to Enable WEP with Unbound Units'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_UNBIND_UNIT_USING_WEP, 'Cannot Unbind Unit When Using WEP'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_NOT_VALID_FOR_UNICAST_MODE, 'Bind changes not valid when in Unicast Mode'],
        [
            Mri.DisplayApi.API_STATUS.API_ERROR_UNSUPPORTED_SCALING,
            'Scaling Between Specified input and output Res currently not supported',
        ],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_FILE_SYSTEM_TYPE, 'Invalid Filesystem type in selected file'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_SYSTEM_TYPE_MISMATCH, 'Filesystem type does not match upload type'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SPI_INTERFACE, 'Error encountered reading / writing on SPI interface'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_MAGIC, 'Invalid Magic in serial connection message header'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_UNBOUND_RCVR_WITH_BOUND_ADDR, 'Unbound receiver with bound IP addr'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_TRACK_CONTROLLER_DISABLED, 'Track Controller disabled'],
        [
            Mri.DisplayApi.API_STATUS.API_ERROR_BROADCAST_RECEIVER_UNAVAIL,
            'Broadcast Software Failed, one or more receivers unavailable',
        ],
        [
            Mri.DisplayApi.API_STATUS.API_ERROR_BROADCAST_RECEIVER_UNBOUND,
            'Broadcast Software Failed, all receivers must be bound',
        ],
        [
            Mri.DisplayApi.API_STATUS.API_ERROR_BROADCAST_FILE_UPLOAD,
            'Broadcast Software Upload failed to one or more receivers',
        ],
        [
            Mri.DisplayApi.API_STATUS.API_ERROR_BROADCAST_FLASH_UPDATE,
            'Broadcast Software Flash Update failed on one or more targets',
        ],
        [Mri.DisplayApi.API_STATUS.API_ERROR_CANNOT_EXEC_PROG, 'Cannot execute program'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_OPEN_SERVER, 'Cannot Open Server'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_BROADCAST_BUSY, 'Software Broadcast In Progress'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INSUFFICIENT_PROTOCOL_VERSION, 'Insufficient Server Protocol Version'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FILE_DOWNLOAD_SEQ, 'File Download Sequence Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_NO_MESSAGES_AVAILABLE, 'No Player Messages Available'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SIG_AGG_TIMEOUT, 'Sig Agg Timeout Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_CONNECTION_CLOSED, 'Connection Closed'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_THREAD_DOES_NOT_EXIST, 'Thread Disabled'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_BAD_SERIAL_CRC, 'Serial API CRC Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_MODBUS_ERROR, 'Modbus Read/Write Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_SERIAL_PORT_BUSY, 'Modbus Serial Port Busy'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_ERROR, 'Wihd Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_SLEEP_MODE, 'Wihd is in sleep mode'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_SOCKET_INIT, 'Wihd Socket Failed'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_TIMEOUT, 'Wihd Command Timeout'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_INVALID_COMMAND, 'Wihd Invalid Command'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_WIHD_OFF, 'Wihd is off'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_ECHO_VERIFY_ERROR, 'Echo Message Verify Error'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_REQUEST_SERVER_RESTART, 'Server Is Restarting'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_INVALID_LICENSE, 'No Valid NTP Time For License Check'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_NO_NTP_TIME_FOR_LICENSE, 'No License For This Feature'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_LICENSE_EXPIRED, 'License Expired For This Feature'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_FRAME_CAPTURE_FAILED, 'Frame Capture Failed'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_ROOTFS_TOO_OLD, 'RootFs Version Too Old'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_KERNEL_TOO_OLD, 'Kernel Version Too Old'],
        [Mri.DisplayApi.API_STATUS.API_ERROR_UNSUPPORTED_IN_RECOVERY_MODE, 'Request Not Supported In Recovery Mode'],
    ]);

    public static JobState = new Map<Mri.DisplayJobs.JobState, string>([
        [Mri.DisplayJobs.JobState.UNDEFINED, 'Undefined'],
        [Mri.DisplayJobs.JobState.PENDING, 'Pending'],
        [Mri.DisplayJobs.JobState.RUNNING, 'Running'],
        [Mri.DisplayJobs.JobState.DONE, 'Done'],
    ]);

    public static JobStatus = new Map<Mri.DisplayJobs.JobStatus, string>([
        [Mri.DisplayJobs.JobStatus.UNDEFINED, 'Undefined'],
        [Mri.DisplayJobs.JobStatus.SUCCESS, 'Success'],
        [Mri.DisplayJobs.JobStatus.FAILURE, 'Failure'],
        [Mri.DisplayJobs.JobStatus.EXCEPTION, 'Exception'],
    ]);

    public static DisplayEventStatus = new Map<Mri.DisplayEvents.DisplayEventStatus, string>([
        [Mri.DisplayEvents.DisplayEventStatus.New, 'New'],
        [Mri.DisplayEvents.DisplayEventStatus.Alert, 'Alert'],
        [Mri.DisplayEvents.DisplayEventStatus.Ticket, 'In Ticket'],
        [Mri.DisplayEvents.DisplayEventStatus.Resolved, 'Resolved'],
        [Mri.DisplayEvents.DisplayEventStatus.Closed, 'Closed'],
        [Mri.DisplayEvents.DisplayEventStatus.Ignored, 'Ignored'],
        [Mri.DisplayEvents.DisplayEventStatus.Delayed, 'Delayed'],
        [Mri.DisplayEvents.DisplayEventStatus.Suppressed, 'Suppressed'],
    ]);

    /// If you change this enum, you will need to update help article
    /// https://support.mri-inc.net/hc/en-us/articles/360000472131-Display-Statuses
    public static DisplayStatus = new Map<Mri.DisplayStatuses.DisplayStatus, string>([
        [Mri.DisplayStatuses.DisplayStatus.OfflineOrInactive, 'Offline Or Inactive'],
        [Mri.DisplayStatuses.DisplayStatus.NeverCommunicated, 'Never Communicated'],
        [Mri.DisplayStatuses.DisplayStatus.Online, 'Online'],
        [Mri.DisplayStatuses.DisplayStatus.Communicating, 'Communicating'],
        [Mri.DisplayStatuses.DisplayStatus.AcPowerLoss, 'Ac Power Loss'],
        [Mri.DisplayStatuses.DisplayStatus.EngineOff, 'Engine is Off'],
        [Mri.DisplayStatuses.DisplayStatus.Standby, 'Standby'],
        [Mri.DisplayStatuses.DisplayStatus.NocCouldNotConnect, 'Noc Could Not Connect'],
        [Mri.DisplayStatuses.DisplayStatus.TimedOut, 'Timed Out'],
        [Mri.DisplayStatuses.DisplayStatus.NocException, 'Noc Exception'],
        [Mri.DisplayStatuses.DisplayStatus.SerialNumberMismatch, 'Serial Number Mismatch'],
        [Mri.DisplayStatuses.DisplayStatus.EngineOffTimedOut, 'Engine is Off, No Connection'],
        [Mri.DisplayStatuses.DisplayStatus.RecoveryServer, 'Recovery Server'],
    ]);

    /// If you change this enum, you will need to update help article
    /// https://support.mri-inc.net/hc/en-us/articles/360000472131-Display-Statuses
    public static DisplayHealth = new Map<Mri.DisplayStatuses.DisplayHealth, string>([
        [Mri.DisplayStatuses.DisplayHealth.Good, 'Good'],
        [Mri.DisplayStatuses.DisplayHealth.Notification, 'Notification'],
        [Mri.DisplayStatuses.DisplayHealth.Warning, 'Warning'],
        [Mri.DisplayStatuses.DisplayHealth.Critical, 'Critical'],
    ]);

    /// If you change this enum, you will need to update help article
    /// https://support.mri-inc.net/hc/en-us/articles/360000472131-Display-Statuses
    public static BacklightState = new Map<Mri.DisplayStatuses.BacklightState, string>([
        [Mri.DisplayStatuses.BacklightState.On, 'On'],
        [Mri.DisplayStatuses.BacklightState.Disabled, 'Disabled'],
        [Mri.DisplayStatuses.BacklightState.StandbyMode, 'Standby Mode'],
    ]);

    /// If you change this enum, you will need to update help article
    /// https://support.mri-inc.net/hc/en-us/articles/360000472131-Display-Statuses
    public static VideoState = new Map<Mri.DisplayStatuses.VideoState, string>([
        [Mri.DisplayStatuses.VideoState.NotConnected, 'Not Connected'],
        [Mri.DisplayStatuses.VideoState.InvalidResolution, 'Invalid Resolution'],
        [Mri.DisplayStatuses.VideoState.InternalError, 'Internal Error'],
        [Mri.DisplayStatuses.VideoState.Valid, 'Valid'],
        [Mri.DisplayStatuses.VideoState.Stalled, 'Stalled'],
        [Mri.DisplayStatuses.VideoState.StalledOnBlack, 'Stalled On Black'],
    ]);

    public static PortalDowntimeIncidentType = new Map<Mri.DisplayApi.DowntimeIncidentTypes, string>([
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AC_INLET_INPUT_VOLTAGE_LOW, 'AC Inlet Low'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SURGE_SUPPRESSOR_FAILED, 'AC surge suppressor failed'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DOOR_OPEN, 'Door Open'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NEED_RESET_DOOR_OPEN, 'Door Open Reset Required'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DISPLAY_SHOCK_DETECTED, 'Display Shock Detected'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_REBOOT_FOR_INVALID_VIDEO_INPUT,
            'Reboot Because Of Invalid video',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STALLED_BLACK_VIDEO, 'Stalled on black image'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STALLED_VIDEO, 'Stalled (or frozen) image'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_INPUT_SIGNAL, 'No video input signal'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STANDBY_ENABLED, 'Standby enabled'],
    ]);

    public static PortalDisplayEventType = new Map<Mri.DisplayEvents.DisplayEventType, string>([
        [Mri.DisplayEvents.DisplayEventType.NocCouldNotConnect, 'BoldVu® Offline'],
    ]);

    public static DowntimeIncidentType = new Map<Mri.DisplayApi.DowntimeIncidentTypes, string>([
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NONE, 'INCIDENT_NONE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_INPUT_SIGNAL, 'INCIDENT_NO_INPUT_SIGNAL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_RECEIVER_COMM, 'INCIDENT_NO_RECEIVER_COMM'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_TRANSMIITER_COMM, 'INCIDENT_NO_TRANSMIITER_COMM'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_I2C_ERROR, 'INCIDENT_I2C_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LOW_FRAME_RATE, 'INCIDENT_LOW_FRAME_RATE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INPUT_OVERFLOW, 'INCIDENT_INPUT_OVERFLOW'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CORRUPT_FRAME, 'INCIDENT_CORRUPT_FRAME'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INPUT_STALLED, 'INCIDENT_INPUT_STALLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_HEATER_STUCK_OFF, 'INCIDENT_HEATER_STUCK_OFF'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_HEATER_STUCK_ON, 'INCIDENT_HEATER_STUCK_ON'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AUTO_BALANCE_FAILURE, 'INCIDENT_AUTO_BALANCE_FAILURE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BLC_DAC_WRITE, 'INCIDENT_BLC_DAC_WRITE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_VALID_LOGO_FILE, 'INCIDENT_NO_VALID_LOGO_FILE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_FPGA_PS_WRITE_FAIL, 'INCIDENT_FPGA_PS_WRITE_FAIL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_FPGA_PS_READ_FAIL, 'INCIDENT_FPGA_PS_READ_FAIL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TAOS_SENSOR, 'INCIDENT_TAOS_SENSOR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AC_INLET_TOO_HIGH, 'INCIDENT_AC_INLET_TOO_HIGH'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_FAILED, 'INCIDENT_POWER_SUPPLY_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DISPLAY_TOO_HOT, 'INCIDENT_DISPLAY_TOO_HOT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DISPLAY_TOO_HOT_SHUTDOWN, 'INCIDENT_DISPLAY_TOO_HOT_SHUTDOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LOST_AC_POWER, 'INCIDENT_LOST_AC_POWER'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_FAN_FAILURE, 'INCIDENT_FAN_FAILURE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_DRIVER_COMM_FAILED, 'INCIDENT_TILE_DRIVER_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PLAYER_NOT_RESPONDING, 'INCIDENT_PLAYER_NOT_RESPONDING'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_OFF, 'INCIDENT_TILE_OFF'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TOO_COLD, 'INCIDENT_TOO_COLD'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DOOR_OPEN, 'INCIDENT_DOOR_OPEN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NEED_RESET_DOOR_OPEN, 'INCIDENT_NEED_RESET_DOOR_OPEN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VIDEO_SERVER_DOWN, 'INCIDENT_VIDEO_SERVER_DOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_GATEWAY_DOWN, 'INCIDENT_GATEWAY_DOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_MODEM_DOWN, 'INCIDENT_MODEM_DOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SYSTEM_STARTUP, 'INCIDENT_SYSTEM_STARTUP'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SYSTEM_SHUTDOWN, 'INCIDENT_SYSTEM_SHUTDOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STANDBY_ENABLED, 'INCIDENT_STANDBY_ENABLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STANDBY_DISABLED, 'INCIDENT_STANDBY_DISABLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STALLED_VIDEO, 'INCIDENT_STALLED_VIDEO'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STALLED_BLACK_VIDEO, 'INCIDENT_STALLED_BLACK_VIDEO'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INVALID_POP_ID, 'INCIDENT_INVALID_POP_ID'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SUREVU_SENSOR_FAILED, 'INCIDENT_SUREVU_SENSOR_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SURGE_SUPPRESSOR_FAILED, 'INCIDENT_SURGE_SUPPRESSOR_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIG_AGG_COMM_FAILED, 'INCIDENT_SIG_AGG_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SLAVE_COMM_FAILED, 'INCIDENT_SLAVE_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BAT_MON_COMM_FAILED, 'INCIDENT_BAT_MON_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VTU_INPUT_VOLTAGE_LOW, 'INCIDENT_VTU_INPUT_VOLTAGE_LOW'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VEHICLE_ENGINE_OFF, 'INCIDENT_VEHICLE_ENGINE_OFF'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_OFF, 'INCIDENT_POWER_SUPPLY_OFF'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LOW_BATTERY_VOLTAGE, 'INCIDENT_LOW_BATTERY_VOLTAGE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SCALER_ERROR, 'INCIDENT_SCALER_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NEXUS_COMM_FAILED, 'INCIDENT_NEXUS_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_500_WATT_PS_FAILED, 'INCIDENT_500_WATT_PS_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_MASTER_COMM_ERROR, 'INCIDENT_MASTER_COMM_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SLAVE_COMM_ERROR, 'INCIDENT_SLAVE_COMM_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_DRIVER_FAIL, 'INCIDENT_TILE_DRIVER_FAIL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PLAYER_EVENT, 'INCIDENT_PLAYER_EVENT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STANDBY, 'INCIDENT_STANDBY'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BKLT_MON_ERROR, 'INCIDENT_BKLT_MON_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TEMP_PROBE_FAILURE, 'INCIDENT_TEMP_PROBE_FAILURE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TEMP_EXCEEDED, 'INCIDENT_TEMP_EXCEEDED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DEFROST_TIMEOUT, 'INCIDENT_DEFROST_TIMEOUT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_MISSED_DEFROST_CYCLE, 'INCIDENT_MISSED_DEFROST_CYCLE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CONTROLLER_COMM_ERROR, 'INCIDENT_CONTROLLER_COMM_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CALC_SUNRISE_SUNSET, 'INCIDENT_CALC_SUNRISE_SUNSET'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LED_FAULT, 'INCIDENT_LED_FAULT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_EXCESSIVE_FAN_FAILURE, 'INCIDENT_EXCESSIVE_FAN_FAILURE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUP_CURRENT_HIGH, 'INCIDENT_POWER_SUP_CURRENT_HIGH'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_MAX_POWER_SUPPLY_LOAD_EXCEEDED,
            'INCIDENT_MAX_POWER_SUPPLY_LOAD_EXCEEDED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_GPS_DATA, 'INCIDENT_NO_GPS_DATA'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_FPGA_SERIAL_COMM, 'INCIDENT_NO_FPGA_SERIAL_COMM'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUP_VOLTAGE_LOW, 'INCIDENT_POWER_SUP_VOLTAGE_LOW'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUP_VOLTAGE_HIGH, 'INCIDENT_POWER_SUP_VOLTAGE_HIGH'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AMBIENT_TEMP_HIGH, 'INCIDENT_AMBIENT_TEMP_HIGH'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VTRIM_HIGH, 'INCIDENT_VTRIM_HIGH'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLIES_HIGH_SHUTDOWN,
            'INCIDENT_POWER_SUPPLIES_HIGH_SHUTDOWN',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VTRIM_HIGH_SHUTDOWN, 'INCIDENT_VTRIM_HIGH_SHUTDOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_WRONG_POWER_SUPPLY, 'INCIDENT_WRONG_POWER_SUPPLY'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INCONSISTENT_BL_CAL, 'INCIDENT_INCONSISTENT_BL_CAL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INPUT_BATTERY_DELTA_V, 'INCIDENT_INPUT_BATTERY_DELTA_V'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VEHICLE_HIGH_CURRENT, 'INCIDENT_VEHICLE_HIGH_CURRENT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INVALID_URSA_VERSION, 'INCIDENT_INVALID_URSA_VERSION'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DEVICE_REBOOTED, 'INCIDENT_DEVICE_REBOOTED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INVALID_TD_FW_VERSION, 'INCIDENT_INVALID_TD_FW_VERSION'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SERVER_BOOT, 'INCIDENT_SERVER_BOOT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_REBOOT_FOR_SEGV, 'INCIDENT_REBOOT_FOR_SEGV'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_URSA_COMM_FAILURE, 'INCIDENT_URSA_COMM_FAILURE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DISPLAY_SHOCK_DETECTED, 'INCIDENT_DISPLAY_SHOCK_DETECTED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_HIGH_HUMIDITY, 'INCIDENT_HIGH_HUMIDITY'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INVALID_SOFTWARE_VERSION, 'INCIDENT_INVALID_SOFTWARE_VERSION'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LONE_12V_POWER_SUPPLY_FAILED,
            'INCIDENT_LONE_12V_POWER_SUPPLY_FAILED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_12V_POWER_SUPPLY_FAILED, 'INCIDENT_12V_POWER_SUPPLY_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SOLAR_BATT_CRITICALLY_LOW, 'INCIDENT_SOLAR_BATT_CRITICALLY_LOW'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_NO_SOLAR_INFO, 'INCIDENT_NO_SOLAR_INFO'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_GENERATOR_RUNNING, 'INCIDENT_GENERATOR_RUNNING'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LOW_SOLAR_BATT_VOLTAGE, 'INCIDENT_LOW_SOLAR_BATT_VOLTAGE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_REBOOT_FOR_STALLED_VIDEO, 'INCIDENT_REBOOT_FOR_STALLED_VIDEO'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_REBOOT_FOR_STALLED_ON_BLACK,
            'INCIDENT_REBOOT_FOR_STALLED_ON_BLACK',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_REBOOT_FOR_INVALID_VIDEO_INPUT,
            'INCIDENT_REBOOT_FOR_INVALID_VIDEO_INPUT',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AC_INLET_AUTODETECT_FAILED,
            'INCIDENT_AC_INLET_AUTODETECT_FAILED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_INVALID_PS_VOLTAGE, 'INCIDENT_INVALID_PS_VOLTAGE'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VTU_INPUT_VOLTAGE_UNKNOWN, 'INCIDENT_VTU_INPUT_VOLTAGE_UNKNOWN'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_VTU_INPUT_VOLTAGE_LOW_DISABLED,
            'INCIDENT_VTU_INPUT_VOLTAGE_LOW_DISABLED',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AC_INLET_INPUT_VOLTAGE_LOW,
            'INCIDENT_AC_INLET_INPUT_VOLTAGE_LOW',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AC_INLET_TOO_HIGH_DISABLED,
            'INCIDENT_AC_INLET_TOO_HIGH_DISABLED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PLAYER_SHUTDOWN, 'INCIDENT_PLAYER_SHUTDOWN'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PLAYER_BROKEN, 'INCIDENT_PLAYER_BROKEN'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_STATUS_INVALID,
            'INCIDENT_POWER_SUPPLY_STATUS_INVALID',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LDIM_SPI_NO_DATA, 'INCIDENT_LDIM_SPI_NO_DATA'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PS_TILE_DRIVER_COMM_FAILED,
            'INCIDENT_PS_TILE_DRIVER_COMM_FAILED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_COMM_FAILED, 'INCIDENT_POWER_SUPPLY_COMM_FAILED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_DRIVER_OPEN_FAULT, 'INCIDENT_TILE_DRIVER_OPEN_FAULT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_DRIVER_SHORT_FAULT, 'INCIDENT_TILE_DRIVER_SHORT_FAULT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TCON_REBOOTED, 'INCIDENT_TCON_REBOOTED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TILE_DRIVER_SPI_FAULT, 'INCIDENT_TILE_DRIVER_SPI_FAULT'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_CURRENT_INVALID,
            'INCIDENT_POWER_SUPPLY_CURRENT_INVALID',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_COMM_ERROR, 'INCIDENT_INFINITETOUCH_COMM_ERROR'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_EXCESSIVE_FREQUENCY_NOISE,
            'INCIDENT_SIGMA_EXCESSIVE_FREQUENCY_NOISE',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_HIGH_RAILED_RECEIVER_COUNT,
            'INCIDENT_SIGMA_HIGH_RAILED_RECEIVER_COUNT',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_TOO_MANY_MITIGATING_RESETS,
            'INCIDENT_SIGMA_TOO_MANY_MITIGATING_RESETS',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_LOW_SELF_AMPLITUDE,
            'INCIDENT_INFINITETOUCH_LOW_SELF_AMPLITUDE',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_LOW_CDAC, 'INCIDENT_INFINITETOUCH_LOW_CDAC'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POWER_SUPPLY_CURRENT_SHARE_FAILURE,
            'INCIDENT_POWER_SUPPLY_CURRENT_SHARE_FAILURE',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_HIGH_MIN_MAX_VOLTAGE_RANGE,
            'INCIDENT_HIGH_MIN_MAX_VOLTAGE_RANGE',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_TOUCHSTORM, 'INCIDENT_INFINITETOUCH_TOUCHSTORM'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_PROGRAMMER_ERROR, 'INCIDENT_PROGRAMMER_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BACKLIGHT_THREAD_DISABLED, 'INCIDENT_BACKLIGHT_THREAD_DISABLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_FANCTRL_THREAD_DISABLED, 'INCIDENT_FANCTRL_THREAD_DISABLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AMPVU_THREAD_DISABLED, 'INCIDENT_AMPVU_THREAD_DISABLED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CRITICAL_THREAD_DISABLED, 'INCIDENT_CRITICAL_THREAD_DISABLED'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BACKLIGHT_THREAD_SUSPENDED,
            'INCIDENT_BACKLIGHT_THREAD_SUSPENDED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_FANCTRL_THREAD_SUSPENDED, 'INCIDENT_FANCTRL_THREAD_SUSPENDED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_AMPVU_THREAD_SUSPENDED, 'INCIDENT_AMPVU_THREAD_SUSPENDED'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CRITICAL_THREAD_SUSPENDED, 'INCIDENT_CRITICAL_THREAD_SUSPENDED'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_MOISTURE_DETECTED,
            'INCIDENT_INFINITETOUCH_MOISTURE_DETECTED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_GENERIC_PROGRAMMER_ERROR, 'INCIDENT_GENERIC_PROGRAMMER_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_HDMI_BAD_LINK_QUALITY, 'INCIDENT_HDMI_BAD_LINK_QUALITY'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LDIM_SPI_PROTOCOL_ERROR, 'INCIDENT_LDIM_SPI_PROTOCOL_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_LDIM_SPI_CHECKSUM_ERROR, 'INCIDENT_LDIM_SPI_CHECKSUM_ERROR'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_TCON_SPI_FAULT, 'INCIDENT_TCON_SPI_FAULT'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_POPVU_RATE_LIMITED, 'INCIDENT_POPVU_RATE_LIMITED'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_12V_POWER_SUPPLY_CURRENT_INVALID,
            'INCIDENT_12V_POWER_SUPPLY_CURRENT_INVALID',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_12V_POWER_SUPPLY_CURRENT_SHARE_FAILURE,
            'INCIDENT_12V_POWER_SUPPLY_CURRENT_SHARE_FAILURE',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DOOR_LATCH_OPEN_SIDE1, 'INCIDENT_DOOR_LATCH_OPEN_SIDE1'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_DOOR_LATCH_OPEN_SIDE2, 'INCIDENT_DOOR_LATCH_OPEN_SIDE2'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_OFFLINE, 'INCIDENT_OFFLINE'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_SIGMA_PING_IDENTIFY_FAILURE,
            'INCIDENT_SIGMA_PING_IDENTIFY_FAILURE',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_UNIT_BAD_SEAL, 'INCIDENT_UNIT_BAD_SEAL'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CONFIG_MISMATCH, 'INCIDENT_CONFIG_MISMATCH'],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_STALLED_PARTIAL_VIDEO, 'INCIDENT_STALLED_PARTIAL_VIDEO'],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BUTTON_MON_THREAD_SUSPENDED,
            'INCIDENT_BUTTON_MON_THREAD_SUSPENDED',
        ],
        [
            Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_BUTTON_MON_THREAD_DISABLED,
            'INCIDENT_BUTTON_MON_THREAD_DISABLED',
        ],
        [Mri.DisplayApi.DowntimeIncidentTypes.INCIDENT_CONFIG_EEPROM_READ_FAILED, 'INCIDENT_CONFIG_EEPROM_READ_FAILED'],
    ]);

    public static DisplayEventType = new Map<Mri.DisplayEvents.DisplayEventType, string>([
        [Mri.DisplayEvents.DisplayEventType.DowntimeIncidentType, 'Downtime Incident'],
        [Mri.DisplayEvents.DisplayEventType.RebootDetected, 'Reboot Detected'],
        [Mri.DisplayEvents.DisplayEventType.DisplaySerialNumberConflict, 'Serial Number Conflict'],
        [Mri.DisplayEvents.DisplayEventType.NocCouldNotConnect, 'Display Offline'],
        [Mri.DisplayEvents.DisplayEventType.WebApiCouldNotConnect, 'WebApi Offline'],
    ]);

    public static DisplayIncidentLevel = new Map<Mri.DisplayApi.IncidentLevel, string>([
        [Mri.DisplayApi.IncidentLevel.IncidentCritical, 'Critical'],
        [Mri.DisplayApi.IncidentLevel.IncidentMajor, 'Major'],
        [Mri.DisplayApi.IncidentLevel.IncidentMinor, 'Minor'],
        [Mri.DisplayApi.IncidentLevel.IncidentNotification, 'Notification'],
        [Mri.DisplayApi.IncidentLevel.IncidentIgnored, 'Ignored'],
    ]);

    public static FileSystemType = new Map<Mri.DisplayApi.FileSystemTypes, string>([
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_UNDEFINED, 'UNKNOWN'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI, 'Mri FS (IXP)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_KERNEL, 'Kernel (IXP)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_BOOT, 'Redboot (IXP)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT, 'Root (IXP)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_LOGO, 'Logo'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG, 'Config'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MULTIPLE, 'Multi-File'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_ATOM, 'Mri FS (Atom)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_BOOT_ATOM, 'Boot (Atom)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_ATOM, 'Root (Atom)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_EEPROM, 'EEPROM Image'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_LED_DRIVER_ARM_FIRMWARE, 'Tile Driver (ARM)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_LED_DRIVER_FPGA_FIRMWARE, 'Tile Driver (FPGA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_POWER_SUPPLY_FPGA_FIRMWARE, 'PS FPGA Firmware'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_CAVIUM, 'Mri FS (Cavium)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_CAVIUM, 'Root (Cavium)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_SUREVU_ARM_FIRMWARE, 'SureVu (ARM)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_TI, 'Mri FS (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_TI, 'Root (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_SIGNAL_AGG_ARM_FIRMWARE, 'Signal Agregator (ARM)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_KERNEL_TI, 'Kernel (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_UBL_TI, 'UBL (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_UBOOT_TI, 'UBOOT (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_TI, 'Config (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_CAVIUM, 'Config (Cavium)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MSP430_FIRMWARE, 'MSP 430 FW'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_NEXUS_FIRMWARE, 'Nexus FW'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_WIHD_XMIT_FIRMWARE, 'WIHD Transmitter FW'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_WIHD_RCVR_FIRMWARE, 'WIHD Receiver FW'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_TEGRA, 'Config (TEGRA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_KERNEL_TEGRA, 'Kernel (TEGRA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_TEGRA, 'Mri (TEGRA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_UBOOT_TEGRA, 'UBoot (TEGRA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_TEGRA, 'Root (TEGRA)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_VPN_CONFIG, 'VPN Config'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_LG, 'Mri FS (LG)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_LG, 'Config (LG)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_BRIGHTSIGN, 'Mri FS (Brightsign)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_BRIGHTSIGN, 'Config (Brightsign)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_CONFIG_X86, 'Config (X86)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_X86, 'Root (x86)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_X86, 'Mri FS (x86)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_URSA_FIRMWARE, 'URSA Firmware'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MISC_DATA, 'Misc Data'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_RECOVERY_TI, 'Recovery (TI)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_URSA11_FIRMWARE, 'URSA11 Firmware'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_BACKLIGHT_CAL, 'Backlight Calibration'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_POWER_SUPPLY_FIRMWARE, 'PSU FW (ARM)'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_INF_TOUCH_FIRMWARE, 'InfiniteTouch® Firmware'],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_INF_TOUCH_FLASH_CONFIG, 'InfiniteTouch® Config'],
    ]);

    public static FileSystemBuildType = new Map<Mri.DisplayApi.FileSystemBuildType, string>([
        [Mri.DisplayApi.FileSystemBuildType.FS_BUILD_RELEASE, 'RELEASE'],
        [Mri.DisplayApi.FileSystemBuildType.FS_BUILD_ENGINEERING, 'ENGINEERING'],
        [Mri.DisplayApi.FileSystemBuildType.FS_BUILD_DEBUG, 'DEBUG'],
        [Mri.DisplayApi.FileSystemBuildType.FS_BUILD_WIP, 'WIP'],
    ]);

    public static FileSystemStatus = new Map<Mri.DisplayApi.FileSystemStatus, string>([
        [Mri.DisplayApi.FileSystemStatus.FS_SUCCESS, 'Success'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_MEMORY_ALLOC, 'Memory Alloc Error'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_FILE_OPEN, 'File Open Error'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_FILE_READ, 'File Read Error'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_FILE_WRITE, 'File Write Error'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_FILE_CRC, 'File CRC Checksum Error'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_INVALID_FILE_SYSTEM_TYPE, 'Invalid Filesystem type in selected file'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_ROOTFS_TOO_OLD, 'RootFs Version Too Old'],
        [Mri.DisplayApi.FileSystemStatus.FS_ERROR_KERNEL_TOO_OLD, 'Kernel Version Too Old'],
    ]);

    public static FileSystemProductType_MRI_FS = new Map<Mri.DisplayApi.FileSystemProductType_MRI_FS, string>([
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_UNDEFINED, 'FS_PROD_MRI_FS_UNDEFINED'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_XMIT_RCVR_2010, 'FS_PROD_MRI_FS_XMIT_RCVR_2010'],
        [
            Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_XMIT_RCVR_3200_4600,
            'FS_PROD_MRI_FS_XMIT_RCVR_3200_4600',
        ],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_TRIPLEVU_4700, 'FS_PROD_MRI_FS_TRIPLEVU_4700'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7000_INDOOR, '7000_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_5700_OUTDOOR, '5700_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_4600_DISNEY, '4600_DISNEY'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7000_OUTDOOR, '7000_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_4600, '4600'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_4700, '4700'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_XMIT_MCAST, 'FS_PROD_MRI_FS_XMIT_MCAST'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_RCVR_MCAST_4700, 'FS_PROD_MRI_FS_RCVR_MCAST_4700'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_5700_INDOOR, '5700_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_UNKNOWN_13, 'FS_PROD_MRI_FS_UNKNOWN_13'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7200, '7200'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_5500, '5500'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7200B, '7200B'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7200C, '7200C'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_5500B, '5500B'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_UNKNOWN_19, 'FS_PROD_MRI_FS_UNKNOWN_19'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS.FS_PROD_MRI_FS_DISP_7200_INDOOR, '7200_INDOOR'],
    ]);

    public static FileSystemProductType_MRI_FS_TI = new Map<Mri.DisplayApi.FileSystemProductType_MRI_FS_TI, string>([
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_UNDEFINED, 'UNDEFINED'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_7200_INDOOR, '7200_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_NEWSSTAND, 'NEWSSTAND'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_7200B_INDOOR, '7200B_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_DISP_TAXI_TOP, 'TAXI_TOP'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500C_INDOOR, '5500C_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_7200D_OUTDOOR, '7200D_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_TEST_FIXTURE, 'TEST_FIXTURE'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_4700_OUTDOOR, '4700_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_8400_OUTDOOR, '8400_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500C_OUTDOOR, '5500C_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_4900_OUTDOOR, '4900_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_4700_INDOOR, '4700_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_RACKET_TOP, 'RACKET_TOP'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_7200C_INDOOR, '7200C_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_COOLER, 'COOLER'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_8400B_OUTDOOR, '8400B_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_8400_INDOOR, '8400_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500D_INDOOR, '5500D_INDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_9800_DEMO, '9800_DEMO'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500E, '5500E'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_DISP_TAXI_TOPB, 'TAXI_TOPB'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_8400D_OUTDOOR, '8400D_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_7500_OUTDOOR, '7500_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_DISP_TAXI_TOPC, 'TAXI_TOPC'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_8600_OUTDOOR, '8600_OUTDOOR'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_3INPUT, '3INPUT'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_GENERIC, 'GENERIC'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500F, '5500F'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500G, '5500G'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_UHD_60HZ_A, 'UHD_60HZ_A'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_UHD_60HZ_B, 'UHD_60HZ_B'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TI.FS_PROD_MRI_FS_TI_5500H, '5500H'],
    ]);

    public static FileSystemProductType_ARM_FIRMWARE = new Map<
    Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE,
    string
    >([
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_UNDEFINED, 'FS_PROD_ARM_FW_UNDEFINED'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_1,
            'FS_PROD_ARM_FW_72_TILE_DRV_1',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_1_TEST,
            'FS_PROD_ARM_FW_72_TILE_DRV_1_TEST',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_192,
            'FS_PROD_ARM_FW_72_TILE_DRV_192',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_192_TEST,
            'FS_PROD_ARM_FW_72_TILE_DRV_192_TEST',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_SURE_VU_POP, 'FS_PROD_ARM_FW_SURE_VU_POP'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_SURE_VU_POP_TEST,
            'FS_PROD_ARM_FW_SURE_VU_POP_TEST',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_TILE_DRV_96,
            'FS_PROD_ARM_FW_55_TILE_DRV_96',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_TILE_DRV_96_TEST,
            'FS_PROD_ARM_FW_55_TILE_DRV_96_TEST',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_SIGNAL_AGG_1, 'FS_PROD_ARM_FW_SIGNAL_AGG_1'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_COOLER_FAN_CTRL,
            'FS_PROD_ARM_FW_COOLER_FAN_CTRL',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_SURE_VU_POP_2,
            'FS_PROD_ARM_FW_SURE_VU_POP_2',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_TILE_DRV_80,
            'FS_PROD_ARM_FW_55_TILE_DRV_80',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_TAXI_TILE_DRV_100,
            'FS_PROD_ARM_FW_TAXI_TILE_DRV_100',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_NEXUS, 'FS_PROD_ARM_FW_NEXUS'],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_NEXUS_2, 'FS_PROD_ARM_FW_NEXUS_2'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_47_TILE_DRV_80,
            'FS_PROD_ARM_FW_47_TILE_DRV_80',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_TILE_DRV_80_CEMUSA,
            'FS_PROD_ARM_FW_55_TILE_DRV_80_CEMUSA',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_TILE_DRV_320,
            'FS_PROD_ARM_FW_84_TILE_DRV_320',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_NEXUS, 'FS_PROD_ARM_FW_84_NEXUS'],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_DEFUNCT_1, 'FS_PROD_ARM_FW_DEFUNCT_1'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_47_TILE_DRV_80_AMPVU,
            'FS_PROD_ARM_FW_47_TILE_DRV_80_AMPVU',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_49_TILE_DRV_30,
            'FS_PROD_ARM_FW_49_TILE_DRV_30',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_RACKET_TILE_DRV_60,
            'FS_PROD_ARM_FW_RACKET_TILE_DRV_60',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_240,
            'FS_PROD_ARM_FW_72_TILE_DRV_240',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72C_INDOOR_NEXUS,
            'FS_PROD_ARM_FW_72C_INDOOR_NEXUS',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_NEXUS2, 'FS_PROD_ARM_FW_84_NEXUS2'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_INDOOR_NEXUS,
            'FS_PROD_ARM_FW_84_INDOOR_NEXUS',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_INDOOR_TILE_DRV_320,
            'FS_PROD_ARM_FW_84_INDOOR_TILE_DRV_320',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_INDOOR_TILE_DRV_160,
            'FS_PROD_ARM_FW_55_INDOOR_TILE_DRV_160',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_INDOOR_NEXUS,
            'FS_PROD_ARM_FW_55_INDOOR_NEXUS',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_TILE_DRV_2_320,
            'FS_PROD_ARM_FW_84_TILE_DRV_2_320',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_LG_5500_TILE_DRV_160,
            'FS_PROD_ARM_FW_LG_5500_TILE_DRV_160',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_72_TILE_DRV_240_WMATA,
            'FS_PROD_ARM_FW_72_TILE_DRV_240_WMATA',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_98_NEXUS_DEMO,
            'FS_PROD_ARM_FW_98_NEXUS_DEMO',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_98_DEMO_TILE_DRV_480,
            'FS_PROD_ARM_FW_98_DEMO_TILE_DRV_480',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_NEXUS3, 'FS_PROD_ARM_FW_84_NEXUS3'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_55_TILE_DRV_120,
            'FS_PROD_ARM_FW_55_TILE_DRV_120',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_TAXI_TILE_DRV_96,
            'FS_PROD_ARM_FW_TAXI_TILE_DRV_96',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_84_TILE_DRV_288,
            'FS_PROD_ARM_FW_84_TILE_DRV_288',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_75_TILE_DRV_192,
            'FS_PROD_ARM_FW_75_TILE_DRV_192',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_COOLER_NEXUS, 'FS_PROD_ARM_FW_COOLER_NEXUS'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_RGBWx2_LED_DRV,
            'FS_PROD_ARM_FW_RGBWx2_LED_DRV',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_TAXI_TILE_DRV_2_96,
            'FS_PROD_ARM_FW_TAXI_TILE_DRV_2_96',
        ],
        [Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_5500B_LDIM, 'FS_PROD_ARM_FW_5500B_LDIM'],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_5500_PS_TILE_DRV_120,
            'FS_PROD_ARM_FW_5500_PS_TILE_DRV_120',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_98_TILE_DRV_2x200_USB,
            'FS_PROD_ARM_FW_98_TILE_DRV_2x200_USB',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_75_TILE_DRV_224_USB,
            'FS_PROD_ARM_FW_75_TILE_DRV_224_USB',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_86_TILE_DRV_360_USB,
            'FS_PROD_ARM_FW_86_TILE_DRV_360_USB',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_ARM_FIRMWARE.FS_PROD_ARM_FW_32_PS_TILE_DRV_48_USB,
            'FS_PROD_ARM_FW_32_PS_TILE_DRV_48_USB',
        ],
    ]);

    public static FileSystemProductType_ROOT_FS = new Map<Mri.DisplayApi.FileSystemProductType_ROOT_FS, string>([
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS.FS_PROD_ROOT_FS_UNDEFINED, 'FS_PROD_ROOT_FS_UNDEFINED'],
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS.FS_PROD_ROOT_FS_WIRELESS_ABG, 'FS_PROD_ROOT_FS_WIRELESS_ABG'],
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS.FS_PROD_ROOT_FS_WIRELESS_N, 'FS_PROD_ROOT_FS_WIRELESS_N'],
    ]);

    public static FileSystemProductType_MSP430_FIRMWARE = new Map<
    Mri.DisplayApi.FileSystemProductType_MSP430_FIRMWARE,
    string
    >([
        [
            Mri.DisplayApi.FileSystemProductType_MSP430_FIRMWARE.FS_PROD_MSP430_FW_UNDEFINED,
            'FS_PROD_MSP430_FW_UNDEFINED',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_MSP430_FIRMWARE.FS_PROD_MSP430_FW_TAXI_BAT_MON_1,
            'FS_PROD_MSP430_FW_TAXI_BAT_MON_1',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_MSP430_FIRMWARE.FS_PROD_MSP430_FW_TAXI_BAT_MON_2,
            'FS_PROD_MSP430_FW_TAXI_BAT_MON_2',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_MSP430_FIRMWARE.FS_PROD_MSP430_FW_TAXI_BAT_MON_3,
            'FS_PROD_MSP430_FW_TAXI_BAT_MON_3',
        ],
    ]);

    public static FileSystemProductType_MRI_FS_TEGRA = new Map<
    Mri.DisplayApi.FileSystemProductType_MRI_FS_TEGRA,
    string
    >([
        [
            Mri.DisplayApi.FileSystemProductType_MRI_FS_TEGRA.FS_PROD_MRI_FS_TEGRA_UNKNOWN,
            'FS_PROD_MRI_FS_TEGRA_UNKNOWN',
        ],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TEGRA.FS_PROD_MRI_FS_TEGRA_EVAL, 'FS_PROD_MRI_FS_TEGRA_EVAL'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_TEGRA.FS_PROD_MRI_FS_TEGRA_COOLER, 'FS_PROD_MRI_FS_TEGRA_COOLER'],
    ]);

    public static FileSystemProductType_MRI_FS_LG = new Map<Mri.DisplayApi.FileSystemProductType_MRI_FS_LG, string>([
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_LG.FS_PROD_MRI_FS_LG_UNKNOWN, 'FS_PROD_MRI_FS_LG_UNKNOWN'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_LG.FS_PROD_MRI_FS_LG_5500, 'FS_PROD_MRI_FS_LG_5500'],
    ]);

    public static FileSystemProductType_ROOT_FS_TEGRA = new Map<
    Mri.DisplayApi.FileSystemProductType_ROOT_FS_TEGRA,
    string
    >([
        [
            Mri.DisplayApi.FileSystemProductType_ROOT_FS_TEGRA.FS_PROD_ROOT_FS_TEGRA_UNKNOWN,
            'FS_PROD_ROOT_FS_TEGRA_UNKNOWN',
        ],
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS_TEGRA.FS_PROD_ROOT_FS_TEGRA_AERVA, 'FS_PROD_ROOT_FS_TEGRA_AERVA'],
    ]);

    public static FileSystemProductType_ROOT_FS_TI = new Map<Mri.DisplayApi.FileSystemProductType_ROOT_FS_TI, string>([
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS_TI.FS_PROD_ROOT_FS_TI_UNKNOWN, 'FS_PROD_ROOT_FS_TI_UKNOWN'],
        [Mri.DisplayApi.FileSystemProductType_ROOT_FS_TI.FS_PROD_ROOT_FS_TI, 'FS_PROD_ROOT_FS_TI'],
    ]);

    public static FileSystemProductType_MRI_FS_BRIGHTSIGN = new Map<
    Mri.DisplayApi.FileSystemProductType_MRI_FS_BRIGHTSIGN,
    string
    >([
        [
            Mri.DisplayApi.FileSystemProductType_MRI_FS_BRIGHTSIGN.FS_PROD_MRI_FS_BRIGHTSIGN_UNKNOWN,
            'FS_PROD_MRI_FS_BRIGHTSIGN_UNKNOWN',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_MRI_FS_BRIGHTSIGN.FS_PROD_MRI_FS_BRIGHTSIGN_COOLER,
            'FS_PROD_MRI_FS_BRIGHTSIGN_COOLER',
        ],
    ]);

    public static FileSystemProductType_ROOT_FS_X86 = new Map<Mri.DisplayApi.FileSystemProductType_ROOT_FS_X86, string>(
        [
            [
                Mri.DisplayApi.FileSystemProductType_ROOT_FS_X86.FS_PROD_ROOT_FS_X86_UNKNOWN,
                'FS_PROD_ROOT_FS_X86_UNKNOWN',
            ],
            [Mri.DisplayApi.FileSystemProductType_ROOT_FS_X86.FS_PROD_ROOT_FS_X86_AERVA, 'FS_PROD_ROOT_FS_X86_AERVA'],
        ]
    );

    public static FileSystemProductType_MRI_FS_X86 = new Map<Mri.DisplayApi.FileSystemProductType_MRI_FS_X86, string>([
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_X86.FS_PROD_MRI_FS_X86_UNKNOWN, 'FS_PROD_MRI_FS_X86_UNKNOWN'],
        [Mri.DisplayApi.FileSystemProductType_MRI_FS_X86.FS_PROD_MRI_FS_X86_COOLER, 'FS_PROD_MRI_FS_X86_COOLER'],
    ]);

    public static FileSystemProductType_MRI_URSA_FIRMWARE = new Map<
    Mri.DisplayApi.FileSystemProductType_MRI_URSA_FIRMWARE,
    string
    >([
        [Mri.DisplayApi.FileSystemProductType_MRI_URSA_FIRMWARE.FS_PROD_URSA_UNKNOWN, 'FS_PROD_URSA_UNKNOWN'],
        [Mri.DisplayApi.FileSystemProductType_MRI_URSA_FIRMWARE.FS_PROD_URSA_8400, 'FS_PROD_URSA_8400'],
    ]);

    public static FileSystemProductType_MRI_URSA11_FIRMWARE = new Map<
    Mri.DisplayApi.FIleSystemProductType_MRI_URSA11_FIRMWARE,
    string
    >([
        [Mri.DisplayApi.FIleSystemProductType_MRI_URSA11_FIRMWARE.FS_PROD_URSA11_UNKNOWN, 'FS_PROD_URSA_UNKNOWN'],
        [Mri.DisplayApi.FIleSystemProductType_MRI_URSA11_FIRMWARE.FS_PROD_URSA11_60HZ, 'URSA11 60Hz'],
        [Mri.DisplayApi.FIleSystemProductType_MRI_URSA11_FIRMWARE.FS_PROD_URSA11_120HZ, 'URSA11 120Hz'],
    ]);

    public static FileSystemProductType_MiscDatafile = new Map<
    Mri.DisplayApi.FileSystemProductType_MiscDatafile,
    string
    >([
        [Mri.DisplayApi.FileSystemProductType_MiscDatafile.FS_PROD_MISC_DATA_UNDEFINED, 'FS_PROD_MISC_DATA_UNDEFINED'],
        [
            Mri.DisplayApi.FileSystemProductType_MiscDatafile.FS_PROD_MISC_DATA_5500B_LDIM_FPGA,
            'FS_PROD_MISC_DATA_5500B_LDIM_FPGA',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_MiscDatafile.FS_PROD_MISC_DATA_5500B_LDIM_TABLES,
            'FS_PROD_MISC_DATA_5500B_LDIM_TABLES',
        ],
    ]);

    public static FileSystemProductType_SigmaFirmware = new Map<
    Mri.DisplayApi.FileSystemProductType_SigmaFirmware,
    string
    >([
        [Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_UNKNOWN, 'FS_PROD_SIGMA_UNKNOWN'],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_POSEIDON,
            'FS_PROD_INFINITETOUCH_TRITON_POSEIDON',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_BOOTLOADER,
            'FS_PROD_INFINITETOUCH_TRITON_BOOTLOADER',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_APPLICATION,
            'FS_PROD_INFINITETOUCH_TRITON_APPLICATION ',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_RESERVED1,
            'FS_PROD_INFINITETOUCH_TRITON_RESERVED1',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_RESERVED2,
            'FS_PROD_INFINITETOUCH_TRITON_RESERVED2 ',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_NEREID1,
            'FS_PROD_INFINITETOUCH_TRITON_NEREID1 ',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_NEREID2,
            'FS_PROD_INFINITETOUCH_TRITON_NEREID2 ',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_PHOEBUS11,
            'FS_PROD_INFINITETOUCH_TRITON_PHOEBUS11 ',
        ],
        [
            Mri.DisplayApi.FileSystemProductType_SigmaFirmware.FS_PROD_SIGMA_TRITON_PHOEBUS12,
            'FS_PROD_INFINITETOUCH_TRITON_PHOEBUS12 ',
        ],
    ]);

    public static FileSystemProductType_SigmaConfig = new Map<Mri.DisplayApi.FileSystemProductType_SigmaConfig, string>(
        [
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_UNKNOWN, 'FS_PROD_INFINITETOUCH_UNKNOWN'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55, 'FS_PROD_SIGMA_TRITON_55'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_55_MOIS_OFF',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP,
                'FS_PROD_SIGMA_TRITON_55_FLIP',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10, 'FS_PROD_SIGMA_TRITON_75_10'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP,
                'FS_PROD_SIGMA_TRITON_75_10_FLIP',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20, 'FS_PROD_SIGMA_TRITON_75_20'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_FLIP,
                'FS_PROD_SIGMA_TRITON_75_20_FLIP',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20, 'FS_PROD_SIGMA_TRITON_86_20'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP,
                'FS_PROD_SIGMA_TRITON_86_20_FLIP',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65, 'FS_PROD_SIGMA_TRITON_65'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_65_MOIS_OFF',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP,
                'FS_PROD_SIGMA_TRITON_65_FLIP',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF,
                'FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_G2, 'FS_PROD_SIGMA_TRITON_55_G2'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_55_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP_G2,
                'FS_PROD_SIGMA_TRITON_55_FLIP_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_G2,
                'FS_PROD_SIGMA_TRITON_75_10_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP_G2,
                'FS_PROD_SIGMA_TRITON_75_10_FLIP_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_G2,
                'FS_PROD_SIGMA_TRITON_75_20_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_FLIP_G2,
                'FS_PROD_SIGMA_TRITON_75_20_FLIP_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_FLIP_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_75_20_FLIP_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_G2,
                'FS_PROD_SIGMA_TRITON_86_20_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_86_20_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP_G2,
                'FS_PROD_SIGMA_TRITON_86_20_FLIP_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF_G2',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_G2, 'FS_PROD_SIGMA_TRITON_65_G2'],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_65_MOIS_OFF_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP_G2,
                'FS_PROD_SIGMA_TRITON_65_FLIP_G2',
            ],
            [
                Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF_G2,
                'FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF_G2',
            ],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_55_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_G3, 'FS_PROD_SIGMA_TRITON_55_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_55_FLIP_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_55_FLIP_G3, 'FS_PROD_SIGMA_TRITON_55_FLIP_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_75_10_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_G3, 'FS_PROD_SIGMA_TRITON_75_10_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_75_10_FLIP_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_10_FLIP_G3, 'FS_PROD_SIGMA_TRITON_75_10_FLIP_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_75_20_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_G3, 'FS_PROD_SIGMA_TRITON_75_20_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_FLIP_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_75_20_FLIP_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_75_20_FLIP_G3, 'FS_PROD_SIGMA_TRITON_75_20_FLIP_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_86_20_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_G3, 'FS_PROD_SIGMA_TRITON_86_20_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_86_20_FLIP_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_86_20_FLIP_G3, 'FS_PROD_SIGMA_TRITON_86_20_FLIP_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_65_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_G3, 'FS_PROD_SIGMA_TRITON_65_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF_G3, 'FS_PROD_SIGMA_TRITON_65_FLIP_MOIS_OFF_G3'],
            [Mri.DisplayApi.FileSystemProductType_SigmaConfig.FS_PROD_SIGMA_TRITON_65_FLIP_G3, 'FS_PROD_SIGMA_TRITON_65_FLIP_G3'],
        ]
    );

    public static FileSystemProductTypes = new Map<Mri.DisplayApi.FileSystemTypes, Map<number, string>>([
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI, Enums.FileSystemProductType_MRI_FS],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_TI, Enums.FileSystemProductType_MRI_FS_TI],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_LED_DRIVER_ARM_FIRMWARE, Enums.FileSystemProductType_ARM_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_LED_DRIVER_FPGA_FIRMWARE, Enums.FileSystemProductType_ARM_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_SUREVU_ARM_FIRMWARE, Enums.FileSystemProductType_ARM_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_SIGNAL_AGG_ARM_FIRMWARE, Enums.FileSystemProductType_ARM_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_NEXUS_FIRMWARE, Enums.FileSystemProductType_ARM_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT, Enums.FileSystemProductType_ROOT_FS],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MSP430_FIRMWARE, Enums.FileSystemProductType_MSP430_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_TEGRA, Enums.FileSystemProductType_MRI_FS_TEGRA],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_LG, Enums.FileSystemProductType_MRI_FS_LG],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_TEGRA, Enums.FileSystemProductType_ROOT_FS_TEGRA],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_TI, Enums.FileSystemProductType_ROOT_FS_TI],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_BRIGHTSIGN, Enums.FileSystemProductType_MRI_FS_BRIGHTSIGN],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_ROOT_X86, Enums.FileSystemProductType_ROOT_FS_X86],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MRI_X86, Enums.FileSystemProductType_MRI_FS_X86],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_URSA_FIRMWARE, Enums.FileSystemProductType_MRI_URSA_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_URSA11_FIRMWARE, Enums.FileSystemProductType_MRI_URSA11_FIRMWARE],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_MISC_DATA, Enums.FileSystemProductType_MiscDatafile],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_INF_TOUCH_FIRMWARE, Enums.FileSystemProductType_SigmaFirmware],
        [Mri.DisplayApi.FileSystemTypes.FS_TYPE_INF_TOUCH_FLASH_CONFIG, Enums.FileSystemProductType_SigmaConfig],
    ]);

    public static UpdSoftwareState = new Map<Mri.DisplayApi.UpdSoftwareState, string>([
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_NONE, 'No Update In Progress'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_STARTED, 'Upload Started'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_COMPLETE, 'Upload Completed'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_FAILED_OPEN, 'Upload Failed File Open'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_FAILED_SEQ, 'Upload Failed Sequence Error'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_FAILED_CRC, 'Upload Failed CRC Error'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UPLOAD_FAILED_FS_TYPE, 'Upload Failed Invalid FileSystem Type'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_ERASING_FLASH, 'Erasing Flash'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_WRITING_FLASH, 'Writing Flash'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_VERIFYING_FLASH, 'Verifying Flash'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_SUCCESSFUL, 'Update Successful'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_FLASH_WRITE_FAILED, 'Flash Write Failed'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_MOUNTING_PARTITION, 'Mount Partition Failed'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_UMMOUNTING_PARTITION, 'Umnmounting Partition Failed'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_SKIPPED, 'Update Skipped, N/A'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_API_ERROR, 'API Error'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_SERVER_OPEN_ERROR, 'Server Open Error'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_ROOTFS_TOO_OLD, 'RootFs Version Too Old'],
        [Mri.DisplayApi.UpdSoftwareState.UPD_SW_STATE_KERNEL_TOO_OLD, 'Kernel Version Too Old'],
    ]);

    public static SoftwareUpdateState = new Map<Mri.DisplaySoftware.SoftwareUpdateState, string>([
        [Mri.DisplaySoftware.SoftwareUpdateState.Idle, 'Idle'],
        [Mri.DisplaySoftware.SoftwareUpdateState.Pending, 'Pending'],
        [Mri.DisplaySoftware.SoftwareUpdateState.Updating, 'Updating'],
        [Mri.DisplaySoftware.SoftwareUpdateState.UpdatingSlave, 'Updating Slave'],
        [Mri.DisplaySoftware.SoftwareUpdateState.Error, 'Error'],
        [Mri.DisplaySoftware.SoftwareUpdateState.NoConnection, 'Could Not Connect'],
        [Mri.DisplaySoftware.SoftwareUpdateState.Scheduled, 'Scheduled'],
        [Mri.DisplaySoftware.SoftwareUpdateState.Updated, 'Updated'],
    ]);

    public static ThreadRequestorId = new Map<Mri.DisplayApi.ThreadRequestorId, string>([
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdNone, 'None'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdSureVu, 'SureVu'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdBkltCtrl, 'BkltCtrl'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdAmpVu, 'AmpVu'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdBatteryMon, 'BatteryMon'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdSystemTest, 'SystemTest'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdClient, 'Client'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdClientExtern, 'ClientExternal'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdSwTest, 'SoftwareTest'],
        [Mri.DisplayApi.ThreadRequestorId.ThreadRequestorIdSwUpdate, 'SoftwareUpdate'],
    ]);

    public static ThreadState = new Map<Mri.DisplayApi.ThreadState, string>([
        [Mri.DisplayApi.ThreadState.THREAD_DISABLED, 'DISABLED'],
        [Mri.DisplayApi.ThreadState.THREAD_STARTING, 'STARTING'],
        [Mri.DisplayApi.ThreadState.THREAD_RUNNING, 'RUNNING'],
        [Mri.DisplayApi.ThreadState.THREAD_SUSPENDED, 'SUSPENDED'],
        [Mri.DisplayApi.ThreadState.THREAD_TERMINATED, 'TERMINATED'],
        [Mri.DisplayApi.ThreadState.THREAD_REQUEST_RUN, 'REQUEST_RUN'],
        [Mri.DisplayApi.ThreadState.THREAD_REQUEST_SUSPEND, 'REQUEST_SUSPEND'],
        [Mri.DisplayApi.ThreadState.THREAD_REQUEST_TERMINATE, 'REQUEST_TERMINATE'],
    ]);

    public static SourceNetwork = new Map<Mri.WebApi.SourceNetwork, string>([
        [Mri.WebApi.SourceNetwork.Unknown, 'Unknown'],
        [Mri.WebApi.SourceNetwork.AB, 'AB'],
        [Mri.WebApi.SourceNetwork.Adshel, 'Adshel'],
        [Mri.WebApi.SourceNetwork.Adspace, 'Adspace'],
        [Mri.WebApi.SourceNetwork.Allure, 'Allure'],
        [Mri.WebApi.SourceNetwork.APN, 'APN'],
        [Mri.WebApi.SourceNetwork.Astral, 'Astral'],
        [Mri.WebApi.SourceNetwork.Avalon, 'Avalon'],
        [Mri.WebApi.SourceNetwork.Cemusa, 'Cemusa'],
        [Mri.WebApi.SourceNetwork.Cineplex, 'Cineplex'],
        [Mri.WebApi.SourceNetwork.ClearChannel, 'ClearChannel'],
        [Mri.WebApi.SourceNetwork.ClearChannelInternational, 'ClearChannelInternational'],
        [Mri.WebApi.SourceNetwork.ClearChannelUk, 'ClearChannelUk'],
        [Mri.WebApi.SourceNetwork.Convergent, 'Convergent'],
        [Mri.WebApi.SourceNetwork.Coke, 'Coke'],
        [Mri.WebApi.SourceNetwork.Ebay, 'Ebay'],
        [Mri.WebApi.SourceNetwork.GGP, 'GGP'],
        [Mri.WebApi.SourceNetwork.Grapevine, 'Grapevine'],
        [Mri.WebApi.SourceNetwork.Intersection, 'Intersection'],
        [Mri.WebApi.SourceNetwork.JCDecaux, 'JCDecaux'],
        [Mri.WebApi.SourceNetwork.LSI, 'LSI'],
        [Mri.WebApi.SourceNetwork.Nascar, 'Nascar'],
        [Mri.WebApi.SourceNetwork.Ocean, 'Ocean'],
        [Mri.WebApi.SourceNetwork.Otima, 'Otima'],
        [Mri.WebApi.SourceNetwork.Outfront, 'Outfront'],
        [Mri.WebApi.SourceNetwork.QMI, 'QMI'],
        [Mri.WebApi.SourceNetwork.Sarmiento, 'Sarmiento'],
        [Mri.WebApi.SourceNetwork.Titan, 'Titan'],
        [Mri.WebApi.SourceNetwork.Verifone, 'Verifone'],
        [Mri.WebApi.SourceNetwork.WaiveCar, 'WaiveCar'],
        [Mri.WebApi.SourceNetwork.Westfield, 'Westfield'],
        [Mri.WebApi.SourceNetwork.YDA, 'YDA'],
    ]);

    public static ServiceLevel = new Map<Mri.Contracts.ServiceLevel, string>([
        [Mri.Contracts.ServiceLevel.Warranty, 'Warranty'],
        [Mri.Contracts.ServiceLevel.SmartVuDepot, 'SmartVu® Portal And Monitoring'],
        [Mri.Contracts.ServiceLevel.SmartVuAdvanced, 'SmartVu® Advanced'],
        [Mri.Contracts.ServiceLevel.Demo, 'Demo'],
        [Mri.Contracts.ServiceLevel.SmartVuCustom, 'SmartVu® Custom'],
        [Mri.Contracts.ServiceLevel.SmartVuPortal, 'SmartVu® Portal'],
        [Mri.Contracts.ServiceLevel.SmartVuGold, 'SmartVu® Gold'],
        [Mri.Contracts.ServiceLevel.SmartVuPlatinum, 'SmartVu® Platinum'],
        [Mri.Contracts.ServiceLevel.MRIStandardWarranty, 'MRI Standard Warranty'],
        [Mri.Contracts.ServiceLevel.OutOfWarranty, 'Out of Warranty'],
    ]);

    public static MeasurementId = new Map<Mri.WebApi.MeasurementId, string>([
        [Mri.WebApi.MeasurementId.SensorIdSourceLocal, 'Local Sensor'],
        [Mri.WebApi.MeasurementId.SensorIdSourcePartner, 'Partner Sensor'],
        [Mri.WebApi.MeasurementId.SensorIdSourceTernary, 'Ternary Sensor'],
        [Mri.WebApi.MeasurementId.UpTime, 'Uptime'],
        [Mri.WebApi.MeasurementId.TimeRunning, 'Time Running'],
        [Mri.WebApi.MeasurementId.CPULoadOneMinuteAvgPct, 'CPU Load One Minute Avg'],
        [Mri.WebApi.MeasurementId.CPULoadFiveMinuteAvgPct, 'CPU Load Five Minute Avg'],
        [Mri.WebApi.MeasurementId.CPULoadTenMinuteAvgPct, 'CPU Load Ten Minute Avg'],
        [Mri.WebApi.MeasurementId.MemoryTotalBytes, 'Memory Total Bytes'],
        [Mri.WebApi.MeasurementId.MemoryFreeBytes, 'Memory Free Bytes'],
        [Mri.WebApi.MeasurementId.MemoryUsedBytes, 'Memory Used Bytes'],
        [Mri.WebApi.MeasurementId.PowerGovernorLimit, 'Power Governor Limit'],
        [Mri.WebApi.MeasurementId.PowerGovernorSource, 'Power Governor Source'],
        [Mri.WebApi.MeasurementId.PowerGovernorSourceName, 'Power Governor Source Name'],
        [Mri.WebApi.MeasurementId.Backlight1Brightness, 'Backlight 1 Brightness'],
        [Mri.WebApi.MeasurementId.Backlight1DesiredBrightness, 'Backlight 1 Desired Brightness'],
        [Mri.WebApi.MeasurementId.AvgBacklight1LightSensor, 'Backlight 1 Light Sensor'],
        [Mri.WebApi.MeasurementId.Backlight1Celsius, 'Backlight 1 Temperature'],
        [Mri.WebApi.MeasurementId.Backlight1DacLevel, 'Backlight 1 DAC'],
        [Mri.WebApi.MeasurementId.Backlight1PwmLevel, 'Backlight 1 PWM'],
        [Mri.WebApi.MeasurementId.AmbientLight1, 'Ambient 1 Light'],
        [Mri.WebApi.MeasurementId.Backlight1MaxCelsius, 'Backlight 1 Max Temperature'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingState, 'Backlight 1 Dimming Enabled'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingPercentEnabled, 'Backlight 1 Dimming'],
        [Mri.WebApi.MeasurementId.Backlight1OnDuration, 'Backlight 1 Duration'],
        [Mri.WebApi.MeasurementId.Backlight1DisabledDuration, 'Backlight 1 Disabled Duration'],
        [Mri.WebApi.MeasurementId.Backlight1StandbyModeDuration, 'Backlight 1 Standby Duration'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingAvgLevel, 'Backlight 1 Block Dimming Savings Avg'],
        [
            Mri.WebApi.MeasurementId.Backlight1BlockDimmingAvgMultiframeLevel,
            'Backlight 1 Block Dimming Savings Avg Multiframe',
        ],
        [Mri.WebApi.MeasurementId.Backlight2Brightness, 'Backlight 2 Brightness'],
        [Mri.WebApi.MeasurementId.Backlight2DesiredBrightness, 'Backlight 2 Desired Brightness'],
        [Mri.WebApi.MeasurementId.AvgBacklight2LightSensor, 'Backlight 2 Light Sensor'],
        [Mri.WebApi.MeasurementId.Backlight2Celsius, 'Backlight 2 Temperature'],
        [Mri.WebApi.MeasurementId.Backlight2DacLevel, 'Backlight 2 DAC'],
        [Mri.WebApi.MeasurementId.Backlight2PwmLevel, 'Backlight 2 PWM'],
        [Mri.WebApi.MeasurementId.AmbientLight2, 'Ambient 2 Light'],
        [Mri.WebApi.MeasurementId.Backlight2MaxCelsius, 'Backlight 2 Max Temperature'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingState, 'Backlight 2 Dimming Enabled'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingPercentEnabled, 'Backlight 2 Dimming'],
        [Mri.WebApi.MeasurementId.Backlight2OnDuration, 'Backlight 2 Duration'],
        [Mri.WebApi.MeasurementId.Backlight2DisabledDuration, 'Backlight 2 Disabled Duration'],
        [Mri.WebApi.MeasurementId.Backlight2StandbyModeDuration, 'Backlight 2 Standby Duration'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingAvgLevel, 'Backlight 2 Block Dimming Savings Avg'],
        [
            Mri.WebApi.MeasurementId.Backlight2BlockDimmingAvgMultiframeLevel,
            'Backlight 2 Block Dimming Savings Avg Multiframe',
        ],
        [Mri.WebApi.MeasurementId.LcdCaseSensor1Celsius, 'LCD Case 1 Temperature'],
        [Mri.WebApi.MeasurementId.LcdCaseSensor2Celsius, 'LCD Case 2 Temperature'],
        [Mri.WebApi.MeasurementId.Tile1SensorCelsius, 'Tile 1 Temperature'],
        [Mri.WebApi.MeasurementId.Tile1LightSensor, 'Tile 1 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile2SensorCelsius, 'Tile 2 Temperature'],
        [Mri.WebApi.MeasurementId.Tile2LightSensor, 'Tile 2 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile3SensorCelsius, 'Tile 3 Temperature'],
        [Mri.WebApi.MeasurementId.Tile3LightSensor, 'Tile 3 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile4SensorCelsius, 'Tile 4 Temperature'],
        [Mri.WebApi.MeasurementId.Tile4LightSensor, 'Tile 4 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile5SensorCelsius, 'Tile 5 Temperature'],
        [Mri.WebApi.MeasurementId.Tile5LightSensor, 'Tile 5 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile6SensorCelsius, 'Tile 6 Temperature'],
        [Mri.WebApi.MeasurementId.Tile6LightSensor, 'Tile 6 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile7SensorCelsius, 'Tile 7 Temperature'],
        [Mri.WebApi.MeasurementId.Tile7LightSensor, 'Tile 7 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile8SensorCelsius, 'Tile 8 Temperature'],
        [Mri.WebApi.MeasurementId.Tile8LightSensor, 'Tile 8 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile9SensorCelsius, 'Tile 9 Temperature'],
        [Mri.WebApi.MeasurementId.Tile9LightSensor, 'Tile 9 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile10SensorCelsius, 'Tile 10 Temperature'],
        [Mri.WebApi.MeasurementId.Tile10LightSensor, 'Tile 10 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile11SensorCelsius, 'Tile 11 Temperature'],
        [Mri.WebApi.MeasurementId.Tile11LightSensor, 'Tile 11 Light Sensor'],
        [Mri.WebApi.MeasurementId.Tile12SensorCelsius, 'Tile 12 Temperature'],
        [Mri.WebApi.MeasurementId.Tile12LightSensor, 'Tile 12 Light Sensor'],
        [Mri.WebApi.MeasurementId.StaticSideBacklightStatus, 'Static Side Backlight Status'],
        [Mri.WebApi.MeasurementId.Sunrise, 'Sunrise'],
        [Mri.WebApi.MeasurementId.Sunset, 'Sunset'],
        [Mri.WebApi.MeasurementId.LocalTime, 'Local Time'],
        [Mri.WebApi.MeasurementId.AvgInletVolts, 'Avg Inlet Volts'],
        [Mri.WebApi.MeasurementId.UnitTotalInletAmps, 'Unit Total Inlet Current'],
        [Mri.WebApi.MeasurementId.UnitTotalPower, 'Unit Total Power'],
        [Mri.WebApi.MeasurementId.UnitTotalV48Amps, 'Unit Total Current'],
        [Mri.WebApi.MeasurementId.TotalInletAmps, 'Total Inlet Current'],
        [Mri.WebApi.MeasurementId.TotalInletWatts, 'Total Inlet Power'],
        [Mri.WebApi.MeasurementId.FilteredInletVolts, 'Filtered Inlet Volts'],
        [Mri.WebApi.MeasurementId.Inlet1Volts, 'Inlet 1 Volts'],
        [Mri.WebApi.MeasurementId.Inlet1Amps, 'Inlet 1 Current'],
        [Mri.WebApi.MeasurementId.Inlet1Watts, 'Inlet 1 Power'],
        [Mri.WebApi.MeasurementId.Inlet2Volts, 'Inlet 2 Volts'],
        [Mri.WebApi.MeasurementId.Inlet2Amps, 'Inlet 2 Current'],
        [Mri.WebApi.MeasurementId.Inlet2Watts, 'Inlet 2 Power'],
        [Mri.WebApi.MeasurementId.Inlet3Volts, 'Inlet 3 Volts'],
        [Mri.WebApi.MeasurementId.Inlet3Amps, 'Inlet 3 Current'],
        [Mri.WebApi.MeasurementId.Inlet3Watts, 'Inlet 3 Power'],
        [Mri.WebApi.MeasurementId.Inlet4Volts, 'Inlet 4 Volts'],
        [Mri.WebApi.MeasurementId.Inlet4Amps, 'Inlet 4 Current'],
        [Mri.WebApi.MeasurementId.Inlet4Watts, 'Inlet 4 Power'],
        [Mri.WebApi.MeasurementId.VtuInletVolts, 'VTU Inlet Volts'],
        [Mri.WebApi.MeasurementId.VtuInletAmps, 'VTU Inlet Current'],
        [Mri.WebApi.MeasurementId.VtuInletWatts, 'VTU Inlet Power'],
        [Mri.WebApi.MeasurementId.VtuVehicleVolts, 'VTU Vehicle Volts'],
        [Mri.WebApi.MeasurementId.VtuVehicleWatts, 'VTU Vehicle Power'],
        [Mri.WebApi.MeasurementId.VtuVoltageDrop, 'VTU Voltage Drop'],
        [Mri.WebApi.MeasurementId.KilowattHour, 'Power Consumption Kilowatt Hours'],
        [Mri.WebApi.MeasurementId.UnitKilowattHour, 'Total Unit Power Consumption Kilowatt Hours'],
        [Mri.WebApi.MeasurementId.PowerSupplyEfficiency, 'Power Supply Efficiency'],
        [Mri.WebApi.MeasurementId.UnitPowerSupplyEfficiency, 'Unit Power Supply Efficiency'],
        [Mri.WebApi.MeasurementId.PowerSupply1Efficiency, 'PSU 1 Efficiency'],
        [Mri.WebApi.MeasurementId.PowerSupply1PF, 'PSU 1 Power Factor'],
        [Mri.WebApi.MeasurementId.PowerSupply2Efficiency, 'PSU 2 Efficiency'],
        [Mri.WebApi.MeasurementId.PowerSupply2PF, 'PSU 2 Power Factor'],
        [Mri.WebApi.MeasurementId.PowerSupply3Efficiency, 'PSU 3 Efficiency'],
        [Mri.WebApi.MeasurementId.PowerSupply3PF, 'PSU 3 Power Factor'],
        [Mri.WebApi.MeasurementId.PowerSupply4Efficiency, 'PSU 4 Efficiency'],
        [Mri.WebApi.MeasurementId.PowerSupply4PF, 'PSU 4 Power Factor'],
        [Mri.WebApi.MeasurementId.OnUpsStatus, 'On UPS'],
        [Mri.WebApi.MeasurementId.BatteryVolts, 'Battery Voltage'],
        [Mri.WebApi.MeasurementId.BatteryAmps, 'Battery Current'],
        [Mri.WebApi.MeasurementId.TotalSolarSupplyWatts, 'Total Solar Supply Watts'],
        [Mri.WebApi.MeasurementId.TotalSolarLoadWatts, 'Total Solar Load Watts'],
        [Mri.WebApi.MeasurementId.SystemBatteryVolts, 'System Battery Voltage'],
        [Mri.WebApi.MeasurementId.TotalAuxACAmps, 'Total Auxillary AC Current'],
        [Mri.WebApi.MeasurementId.TotalSolarBatteryChargeAmps, 'Total Solar Battery Charge Amps'],
        [Mri.WebApi.MeasurementId.CCBattVolts, 'Charge Controller Battery Volts'],
        [Mri.WebApi.MeasurementId.CCInputAmps, 'Charge Controller Input Current'],
        [Mri.WebApi.MeasurementId.CCInputVolts, 'Charge Controller Input Volts'],
        [Mri.WebApi.MeasurementId.CCOuputAmps, 'Charge Controller Ouput Current'],
        [Mri.WebApi.MeasurementId.CCDailyOutputAmpHours, 'Charge Controller Daily Output Amp Hours'],
        [Mri.WebApi.MeasurementId.CCDailyOutputKilowattHours, 'Charge Controller Daily Output Kilowatt Hours'],
        [Mri.WebApi.MeasurementId.InvL1BuyAmps, 'Inverter L1 Buy Amps'],
        [Mri.WebApi.MeasurementId.InvL2BuyAmps, 'Inverter L2 Buy Amps'],
        [Mri.WebApi.MeasurementId.InvL1ChargeAmps, 'Inverter L1 Charge Amps'],
        [Mri.WebApi.MeasurementId.InvL2ChargeAmps, 'Inverter L2 Charge Amps'],
        [Mri.WebApi.MeasurementId.InvL1OutputAmps, 'Inverter L1 Output Amps'],
        [Mri.WebApi.MeasurementId.InvL2OutputAmps, 'Inverter L2 Output Amps'],
        [Mri.WebApi.MeasurementId.InvL1SellAmps, 'Inverter L1 Sell Amps'],
        [Mri.WebApi.MeasurementId.InvL2SellAmps, 'Inverter L2 Sell Amps'],
        [Mri.WebApi.MeasurementId.InvAC1L1Volts, 'Inverter AC1 L1 Volts'],
        [Mri.WebApi.MeasurementId.InvAC1L2Volts, 'Inverter AC1 L2 Volts'],
        [Mri.WebApi.MeasurementId.InvAC2L1Volts, 'Inverter AC2 L1 Volts'],
        [Mri.WebApi.MeasurementId.InvAC2L2Volts, 'Inverter AC2 L2 Volts'],
        [Mri.WebApi.MeasurementId.InvL1ACOutputVolts, 'Inverter L1 AC Output Volts'],
        [Mri.WebApi.MeasurementId.InvL2ACOutputVolts, 'Inverter L2 AC Output Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsuAvgVolts, 'Avg PSU Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsuTotalAmps, 'Total PSU Current'],
        [Mri.WebApi.MeasurementId.PrimaryPsuTotalWatts, 'Total PSU Power'],
        [Mri.WebApi.MeasurementId.PrimaryPsuAvgCelsius, 'Avg PSU Temperature'],
        [Mri.WebApi.MeasurementId.PrimaryPsuExtremeCelsius, 'PSU Min/Max Temperature'],
        [Mri.WebApi.MeasurementId.MaxPowerSupplyTemp, 'Max Power Supply Temp'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Volts, 'PSU 1 Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Amps, 'PSU 1 Current'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Watts, 'PSU 1 Power'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Celsius, 'PSU 1 Temperature'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Vtrim, 'PSU 1 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Volts, 'PSU 2 Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Amps, 'PSU 2 Current'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Watts, 'PSU 2 Power'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Celsius, 'PSU 2 Temperature'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Vtrim, 'PSU 2 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Volts, 'PSU 3 Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Amps, 'PSU 3 Current'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Watts, 'PSU 3 Power'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Celsius, 'PSU 3 Temperature'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Vtrim, 'PSU 3 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Volts, 'PSU 4 Volts'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Amps, 'PSU 4 Current'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Watts, 'PSU 4 Power'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Celsius, 'PSU 4 Temperature'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Vtrim, 'PSU 4 Vtrim'],
        [Mri.WebApi.MeasurementId.V48TotalAmps, 'Total PSU Current'],
        [Mri.WebApi.MeasurementId.V48TotalWatts, 'Total PSU Power'],
        [Mri.WebApi.MeasurementId.V48AvgCelsius, 'Avg PSU Temperature'],
        [Mri.WebApi.MeasurementId.V48AvgVolts, 'Avg PSU Voltage'],
        [Mri.WebApi.MeasurementId.V48Psu1Volts, 'PSU 1 Volts'],
        [Mri.WebApi.MeasurementId.V48Psu1Amps, 'PSU 1 Current'],
        [Mri.WebApi.MeasurementId.V48Psu1Watts, 'PSU 1 Power'],
        [Mri.WebApi.MeasurementId.V48Psu1Celsius, 'PSU 1 Temperature'],
        [Mri.WebApi.MeasurementId.V48Psu2Volts, 'PSU 2 Volts'],
        [Mri.WebApi.MeasurementId.V48Psu2Amps, 'PSU 2 Current'],
        [Mri.WebApi.MeasurementId.V48Psu2Watts, 'PSU 2 Power'],
        [Mri.WebApi.MeasurementId.V48Psu2Celsius, 'PSU 2 Temperature'],
        [Mri.WebApi.MeasurementId.V48Psu3Volts, 'PSU 3 Volts'],
        [Mri.WebApi.MeasurementId.V48Psu3Amps, 'PSU 3 Current'],
        [Mri.WebApi.MeasurementId.V48Psu3Watts, 'PSU 3 Power'],
        [Mri.WebApi.MeasurementId.V48Psu3Celsius, 'PSU 3 Temperature'],
        [Mri.WebApi.MeasurementId.V48Psu4Volts, 'PSU 4 Volts'],
        [Mri.WebApi.MeasurementId.V48Psu4Amps, 'PSU 4 Current'],
        [Mri.WebApi.MeasurementId.V48Psu4Watts, 'PSU 4 Power'],
        [Mri.WebApi.MeasurementId.V48Psu4Celsius, 'PSU 4 Temperature'],
        [Mri.WebApi.MeasurementId.V28TotalAmps, 'Total 28v PSU Current'],
        [Mri.WebApi.MeasurementId.V28TotalWatts, 'Total 28v PSU Power'],
        [Mri.WebApi.MeasurementId.V28AvgCelsius, 'Avg 28v PSU Temperature'],
        [Mri.WebApi.MeasurementId.V28AvgVolts, 'Avg 28v PSU Voltage'],
        [Mri.WebApi.MeasurementId.V28Psu1Volts, 'PSU 1 28v Volts'],
        [Mri.WebApi.MeasurementId.V28Psu1Amps, 'PSU 1 28v Current'],
        [Mri.WebApi.MeasurementId.V28Psu1Watts, 'PSU 1 28v Power'],
        [Mri.WebApi.MeasurementId.V28Psu1Celsius, 'PSU 1 28v Temperature'],
        [Mri.WebApi.MeasurementId.V28Psu2Volts, 'PSU 2 28v Volts'],
        [Mri.WebApi.MeasurementId.V28Psu2Amps, 'PSU 2 28v Current'],
        [Mri.WebApi.MeasurementId.V28Psu2Watts, 'PSU 2 28v Power'],
        [Mri.WebApi.MeasurementId.V28Psu2Celsius, 'PSU 2 28v Temperature'],
        [Mri.WebApi.MeasurementId.V28Psu3Volts, 'PSU 3 28v Volts'],
        [Mri.WebApi.MeasurementId.V28Psu3Amps, 'PSU 3 28v Current'],
        [Mri.WebApi.MeasurementId.V28Psu3Watts, 'PSU 3 28v Power'],
        [Mri.WebApi.MeasurementId.V28Psu3Celsius, 'PSU 3 28v Temperature'],
        [Mri.WebApi.MeasurementId.V28Psu4Volts, 'PSU 4 28v Volts'],
        [Mri.WebApi.MeasurementId.V28Psu4Amps, 'PSU 4 28v Current'],
        [Mri.WebApi.MeasurementId.V28Psu4Watts, 'PSU 4 28v Power'],
        [Mri.WebApi.MeasurementId.V28Psu4Celsius, 'PSU 4 28v Temperature'],
        [Mri.WebApi.MeasurementId.TdPsuTotalAmps, 'Total TileDriver PSU Current'],
        [Mri.WebApi.MeasurementId.TdPsuTotalWatts, 'Total TileDriver PSU Power'],
        [Mri.WebApi.MeasurementId.TdPsuAvgCelsius, 'Avg TileDriver PSU Temperature'],
        [Mri.WebApi.MeasurementId.TdAvgVolts, 'Avg TileDriver PSU Voltage'],
        [Mri.WebApi.MeasurementId.TdPsu1Volts, 'TileDriver PSU 1 Volts'],
        [Mri.WebApi.MeasurementId.TdPsu1Amps, 'TileDriver PSU 1 Current'],
        [Mri.WebApi.MeasurementId.TdPsu1Watts, 'TileDriver PSU 1 Power'],
        [Mri.WebApi.MeasurementId.TdPsu1Celsius, 'TileDriver PSU 1 Temperature'],
        [Mri.WebApi.MeasurementId.TdPsu2Volts, 'TileDriver PSU 2 Volts'],
        [Mri.WebApi.MeasurementId.TdPsu2Amps, 'TileDriver PSU 2 Current'],
        [Mri.WebApi.MeasurementId.TdPsu2Watts, 'TileDriver PSU 2 Power'],
        [Mri.WebApi.MeasurementId.TdPsu2Celsius, 'TileDriver PSU 2 Temperature'],
        [Mri.WebApi.MeasurementId.Psu12VTotalAmps, 'Total 12v PSU Current'],
        [Mri.WebApi.MeasurementId.Psu12VTotalWatts, 'Total 12v PSU Power'],
        [Mri.WebApi.MeasurementId.Psu12VAvgCelsius, 'Avg PSU 12v Temperature'],
        [Mri.WebApi.MeasurementId.Psu1_12VVolts, 'PSU 1 12v Volts'],
        [Mri.WebApi.MeasurementId.Psu1_12VAmps, 'PSU 1 12v Current'],
        [Mri.WebApi.MeasurementId.Psu1_12VWatts, 'PSU 1 12v Power'],
        [Mri.WebApi.MeasurementId.Psu1_12VCelsius, 'PSU 1 12v Temperature'],
        [Mri.WebApi.MeasurementId.V12VPsu1VTrim, 'PSU 1 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu2_12VVolts, 'PSU 2 12v Volts'],
        [Mri.WebApi.MeasurementId.Psu2_12VAmps, 'PSU 2 12v Current'],
        [Mri.WebApi.MeasurementId.Psu2_12VWatts, 'PSU 2 12v Power'],
        [Mri.WebApi.MeasurementId.Psu2_12VCelsius, 'PSU 2 12v Temperature'],
        [Mri.WebApi.MeasurementId.V12VPsu2VTrim, 'PSU 2 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu3_12VVolts, 'PSU 3 12v Volts'],
        [Mri.WebApi.MeasurementId.Psu3_12VAmps, 'PSU 3 12v Current'],
        [Mri.WebApi.MeasurementId.Psu3_12VWatts, 'PSU 3 12v Power'],
        [Mri.WebApi.MeasurementId.Psu3_12VCelsius, 'PSU 3 12v Temperature'],
        [Mri.WebApi.MeasurementId.V12VPsu3VTrim, 'PSU 3 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu4_12VVolts, 'PSU 4 12v Volts'],
        [Mri.WebApi.MeasurementId.Psu4_12VAmps, 'PSU 4 12v Current'],
        [Mri.WebApi.MeasurementId.Psu4_12VWatts, 'PSU 4 12v Power'],
        [Mri.WebApi.MeasurementId.Psu4_12VCelsius, 'PSU 4 12v Temperature'],
        [Mri.WebApi.MeasurementId.V12VPsu4VTrim, 'PSU 4 12v VTrim'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Volts, 'Custom PSU 1 Volts'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Amps, 'Custom PSU 1 Current'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Watts, 'Custom PSU 1 Power'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Celsius, 'Custom PSU 1 Temperature'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Volts, 'Custom PSU 2 Volts'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Amps, 'Custom PSU 2 Current'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Watts, 'Custom PSU 2 Power'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Celsius, 'Custom PSU 2 Temperature'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Volts, 'Custom PSU 3 Volts'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Amps, 'Custom PSU 3 Current'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Watts, 'Custom PSU 3 Power'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Celsius, 'Custom PSU 3 Temperature'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Volts, 'Custom PSU 4 Volts'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Amps, 'Custom PSU 4 Current'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Watts, 'Custom PSU 4 Power'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Celsius, 'Custom PSU 4 Temperature'],
        [Mri.WebApi.MeasurementId.ClosedLoopPwmLevel, 'Closed Loop PWM'],
        [Mri.WebApi.MeasurementId.ClosedLoopCelsius, 'Closed Loop Air Temperature'],
        [Mri.WebApi.MeasurementId.ClosedLoopCelsius2, 'Closed Loop Air Temperature2'],
        [Mri.WebApi.MeasurementId.OpenLoopPwmLevel, 'Open Loop PWM'],
        [Mri.WebApi.MeasurementId.OpenLoopCelsius, 'Open Loop Air Temperature'],
        [Mri.WebApi.MeasurementId.HeatExchangePwmLevel, 'Heat Exchanger PWM'],
        [Mri.WebApi.MeasurementId.FanBank1PwmLevel, 'Fan Bank 1 PWM'],
        [Mri.WebApi.MeasurementId.FanBank2PwmLevel, 'Fan Bank 2 PWM'],
        [Mri.WebApi.MeasurementId.FanBank3PwmLevel, 'Fan Bank 3 PWM'],
        [Mri.WebApi.MeasurementId.FanBank4PwmLevel, 'Fan Bank 4 PWM'],
        [Mri.WebApi.MeasurementId.FanBank5PwmLevel, 'Fan Bank 5 PWM'],
        [Mri.WebApi.MeasurementId.Fan1RPM, 'Fan 1 Speed'],
        [Mri.WebApi.MeasurementId.Fan2RPM, 'Fan 2 Speed'],
        [Mri.WebApi.MeasurementId.Fan3RPM, 'Fan 3 Speed'],
        [Mri.WebApi.MeasurementId.Fan4RPM, 'Fan 4 Speed'],
        [Mri.WebApi.MeasurementId.Fan5RPM, 'Fan 5 Speed'],
        [Mri.WebApi.MeasurementId.Fan6RPM, 'Fan 6 Speed'],
        [Mri.WebApi.MeasurementId.Fan7RPM, 'Fan 7 Speed'],
        [Mri.WebApi.MeasurementId.Fan8RPM, 'Fan 8 Speed'],
        [Mri.WebApi.MeasurementId.Fan9RPM, 'Fan 9 Speed'],
        [Mri.WebApi.MeasurementId.Fan10RPM, 'Fan 10 Speed'],
        [Mri.WebApi.MeasurementId.Fan11RPM, 'Fan 11 Speed'],
        [Mri.WebApi.MeasurementId.Fan12RPM, 'Fan 12 Speed'],
        [Mri.WebApi.MeasurementId.Fan13RPM, 'Fan 13 Speed'],
        [Mri.WebApi.MeasurementId.Fan14RPM, 'Fan 14 Speed'],
        [Mri.WebApi.MeasurementId.Fan15RPM, 'Fan 15 Speed'],
        [Mri.WebApi.MeasurementId.Fan16RPM, 'Fan 16 Speed'],
        [Mri.WebApi.MeasurementId.Fan17RPM, 'Fan 17 Speed'],
        [Mri.WebApi.MeasurementId.Fan18RPM, 'Fan 18 Speed'],
        [Mri.WebApi.MeasurementId.Fan19RPM, 'Fan 19 Speed'],
        [Mri.WebApi.MeasurementId.Fan20RPM, 'Fan 20 Speed'],
        [Mri.WebApi.MeasurementId.CloudCoverRatio, 'Cloud Cover Ratio'],
        [Mri.WebApi.MeasurementId.HumidityLevel, 'Relative Humidity'],
        [Mri.WebApi.MeasurementId.WeatherCode, 'Weather Code'],
        [Mri.WebApi.MeasurementId.BarometricPressure, 'Barometric Pressure'],
        [Mri.WebApi.MeasurementId.WindSpeed, 'Wind Speed'],
        [Mri.WebApi.MeasurementId.WindDirection, 'Wind Direction'],
        [Mri.WebApi.MeasurementId.WindGust, 'Wind Gust'],
        [Mri.WebApi.MeasurementId.Rain1hour, 'Rain 1 Hour'],
        [Mri.WebApi.MeasurementId.Rain3hours, 'Rain 3 Hours'],
        [Mri.WebApi.MeasurementId.Snow1hour, 'Snow 1 Hour'],
        [Mri.WebApi.MeasurementId.Snow3hours, 'Snow 3 Hours'],
        [Mri.WebApi.MeasurementId.LocalHumidity, 'Local Humidity'],
        [Mri.WebApi.MeasurementId.CoolVuZone1Source, 'CoolVu Zone 1 Source'],
        [Mri.WebApi.MeasurementId.CoolVuZone1Celsius, 'CoolVu Zone 1 Temperature'],
        [Mri.WebApi.MeasurementId.CoolVuZone1ChartSource, 'CoolVu Zone 1 Chart Source'],
        [Mri.WebApi.MeasurementId.CoolVuZone2Source, 'CoolVu Zone 2 Source'],
        [Mri.WebApi.MeasurementId.CoolVuZone2Celsius, 'CoolVu Zone 2 Temperature'],
        [Mri.WebApi.MeasurementId.CoolVuZone2ChartSource, 'CoolVu Zone 2 Chart Source'],
        [Mri.WebApi.MeasurementId.FpgaDieCelsius, 'FPGA Die Temperature'],
        [Mri.WebApi.MeasurementId.ProcessorBoardCelsius, 'Processor Board Temperature'],
        [Mri.WebApi.MeasurementId.InletSensorCelsius, 'Inlet Temperature'],
        [Mri.WebApi.MeasurementId.ExhaustSensorCelsius, 'Exhaust Temperature'],
        [Mri.WebApi.MeasurementId.LocalWeatherCelsius, 'Local Weather Temperature'],
        [Mri.WebApi.MeasurementId.AmbientDeltaCelsius, 'Ambient Delta Temperature'],
        [Mri.WebApi.MeasurementId.NexusBoardSensorCelsius, 'Nexus Board Temperature'],
        [Mri.WebApi.MeasurementId.ReceiverBoardSensorCelsius, 'Receiver Board Temperature'],
        [Mri.WebApi.MeasurementId.CoolerSensorCelsius, 'Cooler Temperature'],
        [Mri.WebApi.MeasurementId.EvaporatorSensorCelsius, 'Evaporator Temperature'],
        [Mri.WebApi.MeasurementId.UpperMetalTemp, 'Upper Metal Temp'],
        [Mri.WebApi.MeasurementId.LowerMetalTemp, 'Lower Metal Temp'],
        [Mri.WebApi.MeasurementId.HumidityUpper, 'Humidity Upper'],
        [Mri.WebApi.MeasurementId.HumidityLower, 'Humidity Lower'],
        [Mri.WebApi.MeasurementId.HumiditySensorCelsius, 'Humidity Sensor °C'],
        [Mri.WebApi.MeasurementId.CalculatedDewpoint, 'Calculated Dewpoint'],
        [Mri.WebApi.MeasurementId.DewpointSpread, 'Dewpoint Spread'],
        [Mri.WebApi.MeasurementId.DewpointSpreadUpper, 'Dewpoint Spread Upper'],
        [Mri.WebApi.MeasurementId.DewpointSpreadLower, 'Dewpoint Spread Lower'],
        [Mri.WebApi.MeasurementId.DewpointSpreadUtilized, 'Dewpoint Spread Utilized'],
        [Mri.WebApi.MeasurementId.DewpointInhibitActive, 'Dewpoint Inhibit Active'],
        [Mri.WebApi.MeasurementId.AnyDoorOpenStatus, 'Door Status'],
        [Mri.WebApi.MeasurementId.FrontDoorOpenStatus, 'Front Door Status'],
        [Mri.WebApi.MeasurementId.RearDoorOpenStatus, 'Rear Door Status'],
        [Mri.WebApi.MeasurementId.BottomRearDoorOpenStatus, 'Bottom Rear Door Status'],
        [Mri.WebApi.MeasurementId.SAMDoorOpenStatus, 'SAM Door Status'],
        [Mri.WebApi.MeasurementId.LeftDoorOpenStatus, 'Left Door Status'],
        [Mri.WebApi.MeasurementId.RightDoorOpenStatus, 'Right Door Status'],
        [Mri.WebApi.MeasurementId.Side1MagneticSensorStatus, 'Side 1 Magnetic Sensor Status'],
        [Mri.WebApi.MeasurementId.Side1Latch1Status, 'Side 1 Left Latch Status'],
        [Mri.WebApi.MeasurementId.Side1Latch2Status, 'Side 1 Right Latch Status'],
        [Mri.WebApi.MeasurementId.Side2MagneticSensorStatus, 'Side 2 Magnetic Sensor Status'],
        [Mri.WebApi.MeasurementId.Side2Latch1Status, 'Side 2 Left Latch Status'],
        [Mri.WebApi.MeasurementId.Side2Latch2Status, 'Side 2 Right Latch Status'],
        [Mri.WebApi.MeasurementId.SurgeSuppressorFailedStatus, 'Surge Suppressor Status'],
        [Mri.WebApi.MeasurementId.ELVPressureSensorStatus, 'ELV Pressure Sensor Status'],
        [Mri.WebApi.MeasurementId.PressureDifferential, 'Pressure Diff'],
        [Mri.WebApi.MeasurementId.PressureSensorTemperature, 'Pressure Sensor Temperature'],
        [Mri.WebApi.MeasurementId.SealStatus, 'Seal Status'],
        [Mri.WebApi.MeasurementId.LeakDetected, 'Leak Detected'],
        [Mri.WebApi.MeasurementId.PerCentTimeGpsValid, 'GPS Valid Time'],
        [Mri.WebApi.MeasurementId.GpsHasFix, 'GPS has position fix'],
        [Mri.WebApi.MeasurementId.GpsHDOP, 'GPS Horizontal Dilution of Precision'],
        [Mri.WebApi.MeasurementId.GpsSatInView, 'Number GPS satellite in view'],
        [Mri.WebApi.MeasurementId.GpsSatInFix, 'Number GPS satellite with fix'],
        [Mri.WebApi.MeasurementId.GpsLatitude, 'GPS Position Latitude'],
        [Mri.WebApi.MeasurementId.GpsLongitude, 'GPS Position Longitude'],
        [Mri.WebApi.MeasurementId.SpeedSensor, 'Speed of Vehicle Topper Unit'],
        [Mri.WebApi.MeasurementId.GpsSignalStrength, 'GPS Signal Strength'],
        [Mri.WebApi.MeasurementId.GpsHasValidSerialData, 'GPS has valid serial data'],
        [Mri.WebApi.MeasurementId.Sigma1Uptime, 'InfiniteTouch® 1 Uptime'],
        [Mri.WebApi.MeasurementId.Sigma1FrameCount, 'InfiniteTouch® 1 Frame Count'],
        [Mri.WebApi.MeasurementId.Sigma1FrameRate, 'InfiniteTouch® 1 Frame Rate'],
        [Mri.WebApi.MeasurementId.Sigma1TouchCount, 'InfiniteTouch® 1 Touch Count'],
        [Mri.WebApi.MeasurementId.Sigma1TouchId, 'InfiniteTouch® 1 Touch Id'],
        [Mri.WebApi.MeasurementId.Sigma1RailedCount, 'InfiniteTouch® 1 Railed Count'],
        [Mri.WebApi.MeasurementId.Sigma1NoisyFrequencyCount, 'InfiniteTouch® 1 Noisy Frequency Count'],
        [Mri.WebApi.MeasurementId.Sigma1MitigatingResetCount, 'InfiniteTouch® 1 Mitigating Reset Count'],
        [Mri.WebApi.MeasurementId.Sigma1SelfAmplitude, 'InfiniteTouch® 1 Self Amplitude'],
        [Mri.WebApi.MeasurementId.Sigma1RebaselineCount, 'InfiniteTouch® 1 Rebaseline Count'],
        [Mri.WebApi.MeasurementId.Sigma1CDAC, 'InfiniteTouch® 1 DAC'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1Celsius1, 'InfiniteTouch® 1 Celsius1'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1Celsius2, 'InfiniteTouch® 1 Celsius2'],
        [Mri.WebApi.MeasurementId.Sigma2Uptime, 'InfiniteTouch® 2 Uptime'],
        [Mri.WebApi.MeasurementId.Sigma2FrameCount, 'InfiniteTouch® 2 Frame Count'],
        [Mri.WebApi.MeasurementId.Sigma2FrameRate, 'InfiniteTouch® 2 Frame Rate'],
        [Mri.WebApi.MeasurementId.Sigma2TouchCount, 'InfiniteTouch® 2 Touch Count'],
        [Mri.WebApi.MeasurementId.Sigma2TouchId, 'InfiniteTouch® 2 Touch Id'],
        [Mri.WebApi.MeasurementId.Sigma2RailedCount, 'InfiniteTouch® 2 Railed Count'],
        [Mri.WebApi.MeasurementId.Sigma2NoisyFrequencyCount, 'InfiniteTouch® 2 Noisy Frequency Count'],
        [Mri.WebApi.MeasurementId.Sigma2MitigatingResetCount, 'InfiniteTouch® 2 Mitigating Reset Count'],
        [Mri.WebApi.MeasurementId.Sigma2SelfAmplitude, 'InfiniteTouch® 2 Self Amplitude'],
        [Mri.WebApi.MeasurementId.Sigma2RebaselineCount, 'InfiniteTouch® 2 Rebaseline Count'],
        [Mri.WebApi.MeasurementId.Sigma2CDAC, 'InfiniteTouch® 2 DAC'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2Celsius1, 'InfiniteTouch® 2 Celsius1'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2Celsius2, 'InfiniteTouch® 2 Celsius2'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1GlassType, 'InfiniteTouch® 1 Glass Type'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2GlassType, 'InfiniteTouch® 2 Glass Type'],
        [Mri.WebApi.MeasurementId.MemsRoll, 'Roll'],
        [Mri.WebApi.MeasurementId.MemsPitch, 'Pitch'],
        [Mri.WebApi.MeasurementId.MemsShock, 'Shock'],
        [Mri.WebApi.MeasurementId.Video1InputState, 'Video 1 Input State'],
        [Mri.WebApi.MeasurementId.Video1RxState, 'Video 1 Rx State'],
        [Mri.WebApi.MeasurementId.Video1InputXRes, 'Video 1 Input X Res'],
        [Mri.WebApi.MeasurementId.Video1InputYRes, 'Video 1 Input Y Res'],
        [Mri.WebApi.MeasurementId.Video1InputFramesPerSec, 'Video 1 Input FPS'],
        [Mri.WebApi.MeasurementId.Video1InputPixelClock, 'Video 1 Input Pixel Clock'],
        [Mri.WebApi.MeasurementId.Video1InputValidDuration, 'Video 1 Input Valid Duration'],
        [Mri.WebApi.MeasurementId.Video1InputInvalidDuration, 'Video 1 Input Invalid Duration'],
        [Mri.WebApi.MeasurementId.Video1InputStalledOnBlackDuration, 'Video 1 Input Stalled On Black Duration'],
        [Mri.WebApi.MeasurementId.Video1InputStalledDuration, 'Video 1 Input Stalled Duration'],
        [Mri.WebApi.MeasurementId.Video1InputFullRangeDetected, 'Video 1 Input Full Range Detected'],
        [Mri.WebApi.MeasurementId.Video2InputRxState, 'Video 2 Rx State'],
        [Mri.WebApi.MeasurementId.Video2InputState, 'Video 2 Input State'],
        [Mri.WebApi.MeasurementId.Video2InputXRes, 'Video 2 Input X Res'],
        [Mri.WebApi.MeasurementId.Video2InputYRes, 'Video 2 Input Y Res'],
        [Mri.WebApi.MeasurementId.Video2InputValidDuration, 'Video 2 Input Valid Duration'],
        [Mri.WebApi.MeasurementId.Video2InputInvalidDuration, 'Video 2 Input Invalid Duration'],
        [Mri.WebApi.MeasurementId.Video2InputStalledOnBlackDuration, 'Video 2 Input Stalled On Black Duration'],
        [Mri.WebApi.MeasurementId.Video2InputStalledDuration, 'Video 2 Input Stalled Duration'],
        [Mri.WebApi.MeasurementId.Video2InputFullRangeDetected, 'Video 2 Input Full Range Detected'],
        [Mri.WebApi.MeasurementId.Video1OutputState, 'Video 1 Output State'],
        [Mri.WebApi.MeasurementId.Video1TxState, 'Video 1 Tx State'],
        [Mri.WebApi.MeasurementId.Video1OutputXRes, 'Video 1 Output X Res'],
        [Mri.WebApi.MeasurementId.Video1OutputYRes, 'Video 1 Output Y Res'],
        [Mri.WebApi.MeasurementId.Video1OutputFramesPerSec, 'Video 1 Output FPS'],
        [Mri.WebApi.MeasurementId.Video1OutputPixelClock, 'Video 1 Output Pixel Clock'],
        [Mri.WebApi.MeasurementId.Video1OutputFullRangeDetected, 'Video 1 Output Full Range Detected'],
        [Mri.WebApi.MeasurementId.Video2OutputFullRangeDetected, 'Video 2 Output Full Range Detected'],
        [Mri.WebApi.MeasurementId.VideoRejuvenationModeActive, 'Video Rejuvenation Mode Active'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan1, 'HDMI Link Quality Channel 1'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan2, 'HDMI Link Quality Channel 2'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan3, 'HDMI Link Quality Channel 3'],
        [Mri.WebApi.MeasurementId.UrsaInputXRes, 'Ursa Input X Res'],
        [Mri.WebApi.MeasurementId.UrsaInputYRes, 'Ursa Input Y Res'],
        [Mri.WebApi.MeasurementId.GeoVuSunrise, 'GeoVu Sunrise'],
        [Mri.WebApi.MeasurementId.GeoVuSunset, 'GeoVu Sunset'],
        [Mri.WebApi.MeasurementId.WxSunrise, 'Wx Sunrise'],
        [Mri.WebApi.MeasurementId.WxSunset, 'Wx Sunset'],
        [Mri.WebApi.MeasurementId.WxUtcOffset, 'Wx Utc Offset'],
        [Mri.WebApi.MeasurementId.CurrentTime, 'CurrentTime'],
        [Mri.WebApi.MeasurementId.Timezone, 'Timezone'],
        [Mri.WebApi.MeasurementId.InletUnitDailyMaxCurrent, 'Inlet Daily Max Current'],
        [Mri.WebApi.MeasurementId.InletUnitLifetimeMaxCurrent, 'Inlet Lifetime Max Current'],
    ]);

    public static MeasurementIdSourcePrefix = new Map<Mri.WebApi.MeasurementId, string>([
        [Mri.WebApi.MeasurementId.SensorIdSourceLocal, ''],
        [Mri.WebApi.MeasurementId.SensorIdSourcePartner, 'Partner'],
        [Mri.WebApi.MeasurementId.SensorIdSourceTernary, 'Ternary'],
    ]);

    public static BriefMeasurementId = new Map<Mri.WebApi.MeasurementId, string>([
        [Mri.WebApi.MeasurementId.SensorIdSourceLocal, ''],
        [Mri.WebApi.MeasurementId.SensorIdSourcePartner, 'P'],
        [Mri.WebApi.MeasurementId.SensorIdSourceTernary, 'T'],
        [Mri.WebApi.MeasurementId.UpTime, 'Uptime'],
        [Mri.WebApi.MeasurementId.TimeRunning, 'Time Running'],
        [Mri.WebApi.MeasurementId.CPULoadOneMinuteAvgPct, 'CPU 1 Min.'],
        [Mri.WebApi.MeasurementId.CPULoadFiveMinuteAvgPct, 'CPU 5 Min.'],
        [Mri.WebApi.MeasurementId.CPULoadTenMinuteAvgPct, 'CPU 10 Min.'],
        [Mri.WebApi.MeasurementId.MemoryTotalBytes, 'Total Bytes'],
        [Mri.WebApi.MeasurementId.MemoryFreeBytes, 'Free Bytes'],
        [Mri.WebApi.MeasurementId.MemoryUsedBytes, 'Used Bytes'],
        [Mri.WebApi.MeasurementId.PowerGovernorLimit, 'Power Limit'],
        [Mri.WebApi.MeasurementId.PowerGovernorSource, 'Power Gov Src'],
        [Mri.WebApi.MeasurementId.PowerGovernorSourceName, 'Power Gov Src Name'],
        [Mri.WebApi.MeasurementId.Backlight1Brightness, 'BL1 Nits'],
        [Mri.WebApi.MeasurementId.Backlight1DesiredBrightness, 'BL1 D Nits'],
        [Mri.WebApi.MeasurementId.AvgBacklight1LightSensor, 'BL1 Light'],
        [Mri.WebApi.MeasurementId.Backlight1Celsius, 'BL1 °C'],
        [Mri.WebApi.MeasurementId.Backlight1DacLevel, 'BL1 DAC'],
        [Mri.WebApi.MeasurementId.Backlight1PwmLevel, 'BL1 PWM'],
        [Mri.WebApi.MeasurementId.AmbientLight1, 'Amb1 Light'],
        [Mri.WebApi.MeasurementId.Backlight1MaxCelsius, 'BL1 Max °C'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingState, 'BL1 Dim'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingPercentEnabled, 'BL1 Dim %'],
        [Mri.WebApi.MeasurementId.Backlight1OnDuration, 'BL1 Duration'],
        [Mri.WebApi.MeasurementId.Backlight1DisabledDuration, 'BL1 Disabled'],
        [Mri.WebApi.MeasurementId.Backlight1StandbyModeDuration, 'BL1 Standby'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingAvgLevel, 'BL1 Dim Savings'],
        [Mri.WebApi.MeasurementId.Backlight1BlockDimmingAvgMultiframeLevel, 'BL1 Multiframe Dim Savings'],
        [Mri.WebApi.MeasurementId.Backlight2Brightness, 'BL2 Nits'],
        [Mri.WebApi.MeasurementId.Backlight2DesiredBrightness, 'BL2 D Nits'],
        [Mri.WebApi.MeasurementId.AvgBacklight2LightSensor, 'BL2 Light'],
        [Mri.WebApi.MeasurementId.Backlight2Celsius, 'BL2 °C'],
        [Mri.WebApi.MeasurementId.Backlight2DacLevel, 'BL2 DAC'],
        [Mri.WebApi.MeasurementId.Backlight2PwmLevel, 'BL2 PWM'],
        [Mri.WebApi.MeasurementId.AmbientLight2, 'Amb2 Light'],
        [Mri.WebApi.MeasurementId.Backlight2MaxCelsius, 'BL2 Max °C'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingState, 'BL2 Dim'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingPercentEnabled, 'BL2 Dim %'],
        [Mri.WebApi.MeasurementId.Backlight2OnDuration, 'BL2 Duration'],
        [Mri.WebApi.MeasurementId.Backlight2DisabledDuration, 'BL2 Disabled'],
        [Mri.WebApi.MeasurementId.Backlight2StandbyModeDuration, 'BL2 Standby'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingAvgLevel, 'BL2 Dim Savings'],
        [Mri.WebApi.MeasurementId.Backlight2BlockDimmingAvgMultiframeLevel, 'BL2 Multiframe Dim Savings'],
        [Mri.WebApi.MeasurementId.LcdCaseSensor1Celsius, 'LCD1 °C'],
        [Mri.WebApi.MeasurementId.LcdCaseSensor2Celsius, 'LCD2 °C'],
        [Mri.WebApi.MeasurementId.Tile1SensorCelsius, 'Tile1 °C'],
        [Mri.WebApi.MeasurementId.Tile1LightSensor, 'Tile1 Light'],
        [Mri.WebApi.MeasurementId.Tile2SensorCelsius, 'Tile2 °C'],
        [Mri.WebApi.MeasurementId.Tile2LightSensor, 'Tile2 Light'],
        [Mri.WebApi.MeasurementId.Tile3SensorCelsius, 'Tile3 °C'],
        [Mri.WebApi.MeasurementId.Tile3LightSensor, 'Tile3 Light'],
        [Mri.WebApi.MeasurementId.Tile4SensorCelsius, 'Tile4 °C'],
        [Mri.WebApi.MeasurementId.Tile4LightSensor, 'Tile4 Light'],
        [Mri.WebApi.MeasurementId.Tile5SensorCelsius, 'Tile5 °C'],
        [Mri.WebApi.MeasurementId.Tile5LightSensor, 'Tile5 Light'],
        [Mri.WebApi.MeasurementId.Tile6SensorCelsius, 'Tile6 °C'],
        [Mri.WebApi.MeasurementId.Tile6LightSensor, 'Tile6 Light'],
        [Mri.WebApi.MeasurementId.Tile7SensorCelsius, 'Tile7 °C'],
        [Mri.WebApi.MeasurementId.Tile7LightSensor, 'Tile7 Light'],
        [Mri.WebApi.MeasurementId.Tile8SensorCelsius, 'Tile8 °C'],
        [Mri.WebApi.MeasurementId.Tile8LightSensor, 'Tile8 Light'],
        [Mri.WebApi.MeasurementId.Tile9SensorCelsius, 'Tile9 °C'],
        [Mri.WebApi.MeasurementId.Tile9LightSensor, 'Tile9 Light'],
        [Mri.WebApi.MeasurementId.Tile10SensorCelsius, 'Tile10 °C'],
        [Mri.WebApi.MeasurementId.Tile10LightSensor, 'Tile10 Light'],
        [Mri.WebApi.MeasurementId.Tile11SensorCelsius, 'Tile11 °C'],
        [Mri.WebApi.MeasurementId.Tile11LightSensor, 'Tile11Light'],
        [Mri.WebApi.MeasurementId.Tile12SensorCelsius, 'Tile12 °C'],
        [Mri.WebApi.MeasurementId.Tile12LightSensor, 'Tile12 Light'],
        [Mri.WebApi.MeasurementId.StaticSideBacklightStatus, 'SSBL Status'],
        [Mri.WebApi.MeasurementId.Sunrise, 'Sunrise'],
        [Mri.WebApi.MeasurementId.Sunset, 'Sunset'],
        [Mri.WebApi.MeasurementId.LocalTime, 'Local Time'],
        [Mri.WebApi.MeasurementId.UnitTotalInletAmps, 'Unit Total Inlet Current'],
        [Mri.WebApi.MeasurementId.UnitTotalPower, 'Unit Total Power'],
        [Mri.WebApi.MeasurementId.UnitTotalV48Amps, 'Unit Total Current'],
        [Mri.WebApi.MeasurementId.AvgInletVolts, 'In V'],
        [Mri.WebApi.MeasurementId.TotalInletAmps, 'In C'],
        [Mri.WebApi.MeasurementId.TotalInletWatts, 'In W'],
        [Mri.WebApi.MeasurementId.FilteredInletVolts, 'FiltIn V'],
        [Mri.WebApi.MeasurementId.Inlet1Volts, 'In1 V'],
        [Mri.WebApi.MeasurementId.Inlet1Amps, 'In1 C'],
        [Mri.WebApi.MeasurementId.Inlet1Watts, 'In1 W'],
        [Mri.WebApi.MeasurementId.Inlet2Volts, 'In2 V'],
        [Mri.WebApi.MeasurementId.Inlet2Amps, 'In2 C'],
        [Mri.WebApi.MeasurementId.Inlet2Watts, 'In2 W'],
        [Mri.WebApi.MeasurementId.Inlet3Volts, 'In3 V'],
        [Mri.WebApi.MeasurementId.Inlet3Amps, 'In3 C'],
        [Mri.WebApi.MeasurementId.Inlet3Watts, 'In3 W'],
        [Mri.WebApi.MeasurementId.Inlet4Volts, 'In4 V'],
        [Mri.WebApi.MeasurementId.Inlet4Amps, 'In4 C'],
        [Mri.WebApi.MeasurementId.Inlet4Watts, 'In4 W'],
        [Mri.WebApi.MeasurementId.VtuInletVolts, 'In V'],
        [Mri.WebApi.MeasurementId.VtuInletAmps, 'In C'],
        [Mri.WebApi.MeasurementId.VtuInletWatts, 'In W'],
        [Mri.WebApi.MeasurementId.VtuVehicleVolts, 'Vtu V'],
        [Mri.WebApi.MeasurementId.VtuVehicleWatts, 'Vtu W'],
        [Mri.WebApi.MeasurementId.VtuVoltageDrop, 'V Drop'],
        [Mri.WebApi.MeasurementId.KilowattHour, 'Kw/H'],
        [Mri.WebApi.MeasurementId.UnitKilowattHour, 'Unit Kw/H'],
        [Mri.WebApi.MeasurementId.PowerSupplyEfficiency, 'PS Eff'],
        [Mri.WebApi.MeasurementId.UnitPowerSupplyEfficiency, 'Unit PS Eff'],
        [Mri.WebApi.MeasurementId.PowerSupply1Efficiency, 'PS1 Eff'],
        [Mri.WebApi.MeasurementId.PowerSupply1PF, 'PS1 PF'],
        [Mri.WebApi.MeasurementId.PowerSupply2Efficiency, 'PS2 Eff'],
        [Mri.WebApi.MeasurementId.PowerSupply2PF, 'PS2 PF'],
        [Mri.WebApi.MeasurementId.PowerSupply3Efficiency, 'PS3 Eff'],
        [Mri.WebApi.MeasurementId.PowerSupply3PF, 'PS3 PF'],
        [Mri.WebApi.MeasurementId.PowerSupply4Efficiency, 'PS4 Eff'],
        [Mri.WebApi.MeasurementId.PowerSupply4PF, 'PS4 PF'],
        [Mri.WebApi.MeasurementId.OnUpsStatus, 'On UPS'],
        [Mri.WebApi.MeasurementId.BatteryVolts, 'Batt V'],
        [Mri.WebApi.MeasurementId.BatteryAmps, 'Batt A'],
        [Mri.WebApi.MeasurementId.TotalSolarSupplyWatts, 'Solar Supply W'],
        [Mri.WebApi.MeasurementId.TotalSolarLoadWatts, 'Solar Load W'],
        [Mri.WebApi.MeasurementId.SystemBatteryVolts, 'Batt V'],
        [Mri.WebApi.MeasurementId.TotalAuxACAmps, 'Aux AC A'],
        [Mri.WebApi.MeasurementId.TotalSolarBatteryChargeAmps, 'Solar Batt A'],
        [Mri.WebApi.MeasurementId.CCBattVolts, 'CC Batt V'],
        [Mri.WebApi.MeasurementId.CCInputAmps, 'CC In A'],
        [Mri.WebApi.MeasurementId.CCInputVolts, 'CC In V'],
        [Mri.WebApi.MeasurementId.CCOuputAmps, 'CC Out A'],
        [Mri.WebApi.MeasurementId.CCDailyOutputAmpHours, 'CC DailyOut AmpHrs'],
        [Mri.WebApi.MeasurementId.CCDailyOutputKilowattHours, 'CC DailyOut Kw/Hrs'],
        [Mri.WebApi.MeasurementId.InvL1BuyAmps, 'InvL1Buy A'],
        [Mri.WebApi.MeasurementId.InvL2BuyAmps, 'InvL2Buy A'],
        [Mri.WebApi.MeasurementId.InvL1ChargeAmps, 'InvL1 Charge A'],
        [Mri.WebApi.MeasurementId.InvL2ChargeAmps, 'InvL2 Charge A'],
        [Mri.WebApi.MeasurementId.InvL1OutputAmps, 'InvL1 Out A'],
        [Mri.WebApi.MeasurementId.InvL2OutputAmps, 'InvL2 Out A'],
        [Mri.WebApi.MeasurementId.InvL1SellAmps, 'InvL1 Sell A'],
        [Mri.WebApi.MeasurementId.InvL2SellAmps, 'InvL2 Sell A'],
        [Mri.WebApi.MeasurementId.InvAC1L1Volts, 'InvAC1L1 V'],
        [Mri.WebApi.MeasurementId.InvAC1L2Volts, 'InvAC1L2 V'],
        [Mri.WebApi.MeasurementId.InvAC2L1Volts, 'InvAC2L1 V'],
        [Mri.WebApi.MeasurementId.InvAC2L2Volts, 'InvAC2L2 V'],
        [Mri.WebApi.MeasurementId.InvL1ACOutputVolts, 'InvL1AC Out V'],
        [Mri.WebApi.MeasurementId.InvL2ACOutputVolts, 'InvL2AC Out V'],
        [Mri.WebApi.MeasurementId.PrimaryPsuAvgVolts, 'PS V'],
        [Mri.WebApi.MeasurementId.PrimaryPsuTotalAmps, 'PS A'],
        [Mri.WebApi.MeasurementId.PrimaryPsuTotalWatts, 'PS W'],
        [Mri.WebApi.MeasurementId.PrimaryPsuAvgCelsius, 'PS °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsuExtremeCelsius, 'PS Extreme °C'],
        [Mri.WebApi.MeasurementId.MaxPowerSupplyTemp, 'Max PS °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Volts, 'PS1 V'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Amps, 'PS1 A'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Watts, 'PS1 W'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Celsius, 'PS1 °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsu1Vtrim, 'PS1 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Volts, 'PS2 V'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Amps, 'PS2 A'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Watts, 'PS2 W'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Celsius, 'PS2 °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsu2Vtrim, 'PS2 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Volts, 'PS3 V'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Amps, 'PS3 A'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Watts, 'PS3 W'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Celsius, 'PS3 °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsu3Vtrim, 'PS3 Vtrim'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Volts, 'PS4 V'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Amps, 'PS4 A'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Watts, 'PS4 W'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Celsius, 'PS4 °C'],
        [Mri.WebApi.MeasurementId.PrimaryPsu4Vtrim, 'PS4 Vtrim'],
        [Mri.WebApi.MeasurementId.V48TotalAmps, 'PS Total A'],
        [Mri.WebApi.MeasurementId.V48TotalWatts, 'PS Total W'],
        [Mri.WebApi.MeasurementId.V48AvgCelsius, 'Avg PS °C'],
        [Mri.WebApi.MeasurementId.V48AvgVolts, 'Avg PS V'],
        [Mri.WebApi.MeasurementId.V48Psu1Volts, 'PS1 V'],
        [Mri.WebApi.MeasurementId.V48Psu1Amps, 'PS1 A'],
        [Mri.WebApi.MeasurementId.V48Psu1Watts, 'PS1 W'],
        [Mri.WebApi.MeasurementId.V48Psu1Celsius, 'PS1 °C'],
        [Mri.WebApi.MeasurementId.V48Psu2Volts, 'PS2 V'],
        [Mri.WebApi.MeasurementId.V48Psu2Amps, 'PS2 A'],
        [Mri.WebApi.MeasurementId.V48Psu2Watts, 'PS2 W'],
        [Mri.WebApi.MeasurementId.V48Psu2Celsius, 'PS2 °C'],
        [Mri.WebApi.MeasurementId.V48Psu3Volts, 'PS3 V'],
        [Mri.WebApi.MeasurementId.V48Psu3Amps, 'PS3 A'],
        [Mri.WebApi.MeasurementId.V48Psu3Watts, 'PS3 W'],
        [Mri.WebApi.MeasurementId.V48Psu3Celsius, 'PS3 °C'],
        [Mri.WebApi.MeasurementId.V48Psu4Volts, 'PS4 V'],
        [Mri.WebApi.MeasurementId.V48Psu4Amps, 'PS4 A'],
        [Mri.WebApi.MeasurementId.V48Psu4Watts, 'PS4 W'],
        [Mri.WebApi.MeasurementId.V48Psu4Celsius, 'PS4 °C'],
        [Mri.WebApi.MeasurementId.V28TotalAmps, 'PS 28v A'],
        [Mri.WebApi.MeasurementId.V28TotalWatts, 'PS 28v W'],
        [Mri.WebApi.MeasurementId.V28AvgCelsius, 'Avg28vPS °C'],
        [Mri.WebApi.MeasurementId.V28AvgVolts, 'Avg28vPS V'],
        [Mri.WebApi.MeasurementId.V28Psu1Volts, 'PS1 28v V'],
        [Mri.WebApi.MeasurementId.V28Psu1Amps, 'PS1 28v A'],
        [Mri.WebApi.MeasurementId.V28Psu1Watts, 'PS1 28v W'],
        [Mri.WebApi.MeasurementId.V28Psu1Celsius, 'PS1 28v °C'],
        [Mri.WebApi.MeasurementId.V28Psu2Volts, 'PS2 28v V'],
        [Mri.WebApi.MeasurementId.V28Psu2Amps, 'PS2 28v A'],
        [Mri.WebApi.MeasurementId.V28Psu2Watts, 'PS2 28v W'],
        [Mri.WebApi.MeasurementId.V28Psu2Celsius, 'PS2 28v °C'],
        [Mri.WebApi.MeasurementId.V28Psu3Volts, 'PS3 28v V'],
        [Mri.WebApi.MeasurementId.V28Psu3Amps, 'PS3 28v A'],
        [Mri.WebApi.MeasurementId.V28Psu3Watts, 'PS3 28v W'],
        [Mri.WebApi.MeasurementId.V28Psu3Celsius, 'PS3 28v °C'],
        [Mri.WebApi.MeasurementId.V28Psu4Volts, 'PS4 28v V'],
        [Mri.WebApi.MeasurementId.V28Psu4Amps, 'PS4 28v A'],
        [Mri.WebApi.MeasurementId.V28Psu4Watts, 'PS4 28v W'],
        [Mri.WebApi.MeasurementId.V28Psu4Celsius, 'PS4 28v °C'],
        [Mri.WebApi.MeasurementId.TdPsuTotalAmps, 'PS A'],
        [Mri.WebApi.MeasurementId.TdPsuTotalWatts, 'PS W'],
        [Mri.WebApi.MeasurementId.TdPsuAvgCelsius, 'PS °C'],
        [Mri.WebApi.MeasurementId.TdAvgVolts, 'PS V'],
        [Mri.WebApi.MeasurementId.TdPsu1Volts, 'TdPS1 V'],
        [Mri.WebApi.MeasurementId.TdPsu1Amps, 'TdPS1 A'],
        [Mri.WebApi.MeasurementId.TdPsu1Watts, 'TdPS1 W'],
        [Mri.WebApi.MeasurementId.TdPsu1Celsius, 'TdPS1 °C'],
        [Mri.WebApi.MeasurementId.TdPsu2Volts, 'TdPS2 V'],
        [Mri.WebApi.MeasurementId.TdPsu2Amps, 'TdPS2 A'],
        [Mri.WebApi.MeasurementId.TdPsu2Watts, 'TdPS2 W'],
        [Mri.WebApi.MeasurementId.TdPsu2Celsius, 'TdPS2 °C'],
        [Mri.WebApi.MeasurementId.Psu12VTotalAmps, 'PS 12v A'],
        [Mri.WebApi.MeasurementId.Psu12VTotalWatts, 'PS 12v W'],
        [Mri.WebApi.MeasurementId.Psu12VAvgCelsius, 'Avg PS 12v °C'],
        [Mri.WebApi.MeasurementId.Psu1_12VVolts, 'PS1 12v V'],
        [Mri.WebApi.MeasurementId.Psu1_12VAmps, 'PS1 12v A'],
        [Mri.WebApi.MeasurementId.Psu1_12VWatts, 'PS1 12v W'],
        [Mri.WebApi.MeasurementId.Psu1_12VCelsius, 'PS1 12v °C'],
        [Mri.WebApi.MeasurementId.V12VPsu1VTrim, 'PS1 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu2_12VVolts, 'PS2 12v V'],
        [Mri.WebApi.MeasurementId.Psu2_12VAmps, 'PS2 12v A'],
        [Mri.WebApi.MeasurementId.Psu2_12VWatts, 'PS2 12v W'],
        [Mri.WebApi.MeasurementId.Psu2_12VCelsius, 'PS2 12v °C'],
        [Mri.WebApi.MeasurementId.V12VPsu2VTrim, 'PS2 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu3_12VVolts, 'PS3 12v V'],
        [Mri.WebApi.MeasurementId.Psu3_12VAmps, 'PS3 12v A'],
        [Mri.WebApi.MeasurementId.Psu3_12VWatts, 'PS3 12v W'],
        [Mri.WebApi.MeasurementId.Psu3_12VCelsius, 'PS3 12v °C'],
        [Mri.WebApi.MeasurementId.V12VPsu3VTrim, 'PS3 12v VTrim'],
        [Mri.WebApi.MeasurementId.Psu4_12VVolts, 'PS4 12v V'],
        [Mri.WebApi.MeasurementId.Psu4_12VAmps, 'PS4 12v A'],
        [Mri.WebApi.MeasurementId.Psu4_12VWatts, 'PS4 12v W'],
        [Mri.WebApi.MeasurementId.Psu4_12VCelsius, 'PS4 12v °C'],
        [Mri.WebApi.MeasurementId.V12VPsu4VTrim, 'PS4 12v VTrim'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Volts, 'CPS1 V'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Amps, 'CPS1 A'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Watts, 'CPS1 W'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu1Celsius, 'CPS1 °C'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Volts, 'CPS2 V'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Amps, 'CPS2 A'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Watts, 'CPS2 W'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu2Celsius, 'CPS2 °C'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Volts, 'CPS3 V'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Amps, 'CPS3 A'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Watts, 'CPS3 W'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu3Celsius, 'CPS3 °C'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Volts, 'CPS4 V'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Amps, 'CPS4 A'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Watts, 'CPS4 W'],
        [Mri.WebApi.MeasurementId.CustomAuxPsu4Celsius, 'CPS4 °C'],
        [Mri.WebApi.MeasurementId.ClosedLoopPwmLevel, 'Closed PWM'],
        [Mri.WebApi.MeasurementId.ClosedLoopCelsius, 'Closed °C'],
        [Mri.WebApi.MeasurementId.ClosedLoopCelsius2, 'Closed2 °C'],
        [Mri.WebApi.MeasurementId.OpenLoopPwmLevel, 'Open PWM'],
        [Mri.WebApi.MeasurementId.OpenLoopCelsius, 'Open °C'],
        [Mri.WebApi.MeasurementId.HeatExchangePwmLevel, 'Heat Exch PWM'],
        [Mri.WebApi.MeasurementId.FanBank1PwmLevel, 'Fan1 %'],
        [Mri.WebApi.MeasurementId.FanBank2PwmLevel, 'Fan2 %'],
        [Mri.WebApi.MeasurementId.FanBank3PwmLevel, 'Fan3 %'],
        [Mri.WebApi.MeasurementId.FanBank4PwmLevel, 'Fan4 %'],
        [Mri.WebApi.MeasurementId.FanBank5PwmLevel, 'Fan5 %'],
        [Mri.WebApi.MeasurementId.Fan1RPM, 'Fan1 RPM'],
        [Mri.WebApi.MeasurementId.Fan2RPM, 'Fan2 RPM'],
        [Mri.WebApi.MeasurementId.Fan3RPM, 'Fan3 RPM'],
        [Mri.WebApi.MeasurementId.Fan4RPM, 'Fan4 RPM'],
        [Mri.WebApi.MeasurementId.Fan5RPM, 'Fan5 RPM'],
        [Mri.WebApi.MeasurementId.Fan6RPM, 'Fan6 RPM'],
        [Mri.WebApi.MeasurementId.Fan7RPM, 'Fan7 RPM'],
        [Mri.WebApi.MeasurementId.Fan8RPM, 'Fan8 RPM'],
        [Mri.WebApi.MeasurementId.Fan9RPM, 'Fan9 RPM'],
        [Mri.WebApi.MeasurementId.Fan10RPM, 'Fan10 RPM'],
        [Mri.WebApi.MeasurementId.Fan11RPM, 'Fan11 RPM'],
        [Mri.WebApi.MeasurementId.Fan12RPM, 'Fan12 RPM'],
        [Mri.WebApi.MeasurementId.Fan13RPM, 'Fan13 RPM'],
        [Mri.WebApi.MeasurementId.Fan14RPM, 'Fan14 RPM'],
        [Mri.WebApi.MeasurementId.Fan15RPM, 'Fan15 RPM'],
        [Mri.WebApi.MeasurementId.Fan16RPM, 'Fan16 RPM'],
        [Mri.WebApi.MeasurementId.Fan17RPM, 'Fan17 RPM'],
        [Mri.WebApi.MeasurementId.Fan18RPM, 'Fan18 RPM'],
        [Mri.WebApi.MeasurementId.Fan19RPM, 'Fan19 RPM'],
        [Mri.WebApi.MeasurementId.Fan20RPM, 'Fan20 RPM'],
        [Mri.WebApi.MeasurementId.CloudCoverRatio, 'CC %'],
        [Mri.WebApi.MeasurementId.HumidityLevel, 'RH'],
        [Mri.WebApi.MeasurementId.WeatherCode, 'Code'],
        [Mri.WebApi.MeasurementId.BarometricPressure, 'Bar'],
        [Mri.WebApi.MeasurementId.WindSpeed, 'Speed'],
        [Mri.WebApi.MeasurementId.WindDirection, 'Dir'],
        [Mri.WebApi.MeasurementId.WindGust, 'Gust'],
        [Mri.WebApi.MeasurementId.Rain1hour, 'Rain1'],
        [Mri.WebApi.MeasurementId.Rain3hours, 'Rain3'],
        [Mri.WebApi.MeasurementId.Snow1hour, 'Snow1'],
        [Mri.WebApi.MeasurementId.Snow3hours, 'Snow3'],
        [Mri.WebApi.MeasurementId.LocalHumidity, 'LH'],
        [Mri.WebApi.MeasurementId.CoolVuZone1Source, 'Zone1 Source'],
        [Mri.WebApi.MeasurementId.CoolVuZone1ChartSource, 'Zone1 Chart'],
        [Mri.WebApi.MeasurementId.CoolVuZone1Celsius, 'Zone1 °C'],
        [Mri.WebApi.MeasurementId.CoolVuZone2Source, 'Zone2 Source'],
        [Mri.WebApi.MeasurementId.CoolVuZone2ChartSource, 'Zone2 Chart'],
        [Mri.WebApi.MeasurementId.CoolVuZone2Celsius, 'Zone2 °C'],
        [Mri.WebApi.MeasurementId.FpgaDieCelsius, 'FPGA °C'],
        [Mri.WebApi.MeasurementId.ProcessorBoardCelsius, 'Proc °C'],
        [Mri.WebApi.MeasurementId.InletSensorCelsius, 'Inlet °C'],
        [Mri.WebApi.MeasurementId.ExhaustSensorCelsius, 'Exhaust °C'],
        [Mri.WebApi.MeasurementId.LocalWeatherCelsius, 'Local °C'],
        [Mri.WebApi.MeasurementId.AmbientDeltaCelsius, 'AmbD °C'],
        [Mri.WebApi.MeasurementId.NexusBoardSensorCelsius, 'Nexus °C'],
        [Mri.WebApi.MeasurementId.ReceiverBoardSensorCelsius, 'Rec °C'],
        [Mri.WebApi.MeasurementId.CoolerSensorCelsius, 'Cooler °C'],
        [Mri.WebApi.MeasurementId.EvaporatorSensorCelsius, 'Evap °C'],
        [Mri.WebApi.MeasurementId.UpperMetalTemp, 'Upper Metal'],
        [Mri.WebApi.MeasurementId.LowerMetalTemp, 'Lower Metal'],
        [Mri.WebApi.MeasurementId.HumidityUpper, 'Humidity Upper'],
        [Mri.WebApi.MeasurementId.HumidityLower, 'Humidity Lower'],
        [Mri.WebApi.MeasurementId.HumiditySensorCelsius, 'H °C'],
        [Mri.WebApi.MeasurementId.CalculatedDewpoint, 'DP'],
        [Mri.WebApi.MeasurementId.DewpointSpread, 'DP Spread'],
        [Mri.WebApi.MeasurementId.DewpointSpreadUpper, 'DPS Upper'],
        [Mri.WebApi.MeasurementId.DewpointSpreadLower, 'DPS Lower'],
        [Mri.WebApi.MeasurementId.DewpointSpreadUtilized, 'DPS Utilized'],
        [Mri.WebApi.MeasurementId.DewpointInhibitActive, 'Dewpoint Inhibit Active'],
        [Mri.WebApi.MeasurementId.AnyDoorOpenStatus, 'Door'],
        [Mri.WebApi.MeasurementId.FrontDoorOpenStatus, 'Front Door'],
        [Mri.WebApi.MeasurementId.RearDoorOpenStatus, 'Rear Door'],
        [Mri.WebApi.MeasurementId.BottomRearDoorOpenStatus, 'BR Door'],
        [Mri.WebApi.MeasurementId.SAMDoorOpenStatus, 'SAM Door'],
        [Mri.WebApi.MeasurementId.LeftDoorOpenStatus, 'Left Door'],
        [Mri.WebApi.MeasurementId.RightDoorOpenStatus, 'Right Door'],
        [Mri.WebApi.MeasurementId.Side1MagneticSensorStatus, 'Side 1 Magnet Status'],
        [Mri.WebApi.MeasurementId.Side1Latch1Status, 'Side 1 Left Latch'],
        [Mri.WebApi.MeasurementId.Side1Latch2Status, 'Side 1 Right Latch'],
        [Mri.WebApi.MeasurementId.Side2MagneticSensorStatus, 'Side 2 Magnet Status'],
        [Mri.WebApi.MeasurementId.Side2Latch1Status, 'Side 2 Left Latch'],
        [Mri.WebApi.MeasurementId.Side2Latch2Status, 'Side 2 Right Latch'],
        [Mri.WebApi.MeasurementId.SurgeSuppressorFailedStatus, 'Surge'],
        [Mri.WebApi.MeasurementId.ELVPressureSensorStatus, 'Pressure Status'],
        [Mri.WebApi.MeasurementId.PressureDifferential, 'Pressure Diff'],
        [Mri.WebApi.MeasurementId.PressureSensorTemperature, 'Pressure °C'],
        [Mri.WebApi.MeasurementId.SealStatus, 'Seal Status'],
        [Mri.WebApi.MeasurementId.LeakDetected, 'Leak Detected'],
        [Mri.WebApi.MeasurementId.PerCentTimeGpsValid, 'GPS Valid %'],
        [Mri.WebApi.MeasurementId.GpsHasFix, 'GPS Fix'],
        [Mri.WebApi.MeasurementId.GpsHDOP, 'GPS HDOP'],
        [Mri.WebApi.MeasurementId.GpsSatInView, '#Sats'],
        [Mri.WebApi.MeasurementId.GpsSatInFix, '#Fix'],
        [Mri.WebApi.MeasurementId.GpsLatitude, 'Latitude'],
        [Mri.WebApi.MeasurementId.GpsLongitude, 'Longitude'],
        [Mri.WebApi.MeasurementId.SpeedSensor, 'Speed'],
        [Mri.WebApi.MeasurementId.GpsSignalStrength, 'GPS Signal'],
        [Mri.WebApi.MeasurementId.GpsHasValidSerialData, 'GPS Valid'],
        [Mri.WebApi.MeasurementId.Sigma1Uptime, 'IT1 Uptime'],
        [Mri.WebApi.MeasurementId.Sigma1FrameCount, 'IT1 Frame Count'],
        [Mri.WebApi.MeasurementId.Sigma1FrameRate, 'IT1 Frame Rate'],
        [Mri.WebApi.MeasurementId.Sigma1TouchCount, 'IT1 Touch Count'],
        [Mri.WebApi.MeasurementId.Sigma1TouchId, 'IT1 Touch Id'],
        [Mri.WebApi.MeasurementId.Sigma1RailedCount, 'IT1 Railed Count'],
        [Mri.WebApi.MeasurementId.Sigma1NoisyFrequencyCount, 'IT1 Noisy Freq'],
        [Mri.WebApi.MeasurementId.Sigma1MitigatingResetCount, 'IT1 Miti Reset'],
        [Mri.WebApi.MeasurementId.Sigma1SelfAmplitude, 'IT1 Self Amp'],
        [Mri.WebApi.MeasurementId.Sigma1RebaselineCount, 'IT1 Rebase Line '],
        [Mri.WebApi.MeasurementId.Sigma1CDAC, 'IT1 DAC'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1Celsius1, 'IT1 °C1'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1Celsius2, 'IT1 °C2'],
        [Mri.WebApi.MeasurementId.Sigma2Uptime, 'IT2 Uptime'],
        [Mri.WebApi.MeasurementId.Sigma2FrameCount, 'IT2 Frame Count'],
        [Mri.WebApi.MeasurementId.Sigma2FrameRate, 'IT2 Frame2 Rate'],
        [Mri.WebApi.MeasurementId.Sigma2TouchCount, 'IT2 Touch Count'],
        [Mri.WebApi.MeasurementId.Sigma2TouchId, 'IT2 Touch Id'],
        [Mri.WebApi.MeasurementId.Sigma2RailedCount, 'IT2 Railed Count'],
        [Mri.WebApi.MeasurementId.Sigma2NoisyFrequencyCount, 'IT2 Noisy Freq'],
        [Mri.WebApi.MeasurementId.Sigma2MitigatingResetCount, 'IT2 Miti Reset'],
        [Mri.WebApi.MeasurementId.Sigma2SelfAmplitude, 'IT2 Self mp'],
        [Mri.WebApi.MeasurementId.Sigma2RebaselineCount, 'IT2 Rebase Line'],
        [Mri.WebApi.MeasurementId.Sigma2CDAC, 'IT2 DAC'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2Celsius1, 'IT2 °C1'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2Celsius2, 'IT2 °C2'],
        [Mri.WebApi.MeasurementId.MemsRoll, 'Roll'],
        [Mri.WebApi.MeasurementId.MemsPitch, 'Pitch'],
        [Mri.WebApi.MeasurementId.MemsShock, 'Shock'],
        [Mri.WebApi.MeasurementId.Video1InputState, 'Video1 InState'],
        [Mri.WebApi.MeasurementId.Video1RxState, 'Video1 RxState'],
        [Mri.WebApi.MeasurementId.Video1InputXRes, 'Video1 InX'],
        [Mri.WebApi.MeasurementId.Video1InputYRes, 'Video1 InY'],
        [Mri.WebApi.MeasurementId.Video1InputFramesPerSec, 'Video1 InFPS'],
        [Mri.WebApi.MeasurementId.Video1InputPixelClock, 'Video1In Pixel Clock'],
        [Mri.WebApi.MeasurementId.Video1InputValidDuration, 'Video1In Valid'],
        [Mri.WebApi.MeasurementId.Video1InputInvalidDuration, 'Video1In Invalid'],
        [Mri.WebApi.MeasurementId.Video1InputStalledOnBlackDuration, 'Video1In Black'],
        [Mri.WebApi.MeasurementId.Video1InputStalledDuration, 'Video1In Stalled'],
        [Mri.WebApi.MeasurementId.Video1InputFullRangeDetected, 'Video1In Full Range'],
        [Mri.WebApi.MeasurementId.Video2InputRxState, 'Video2Rx State'],
        [Mri.WebApi.MeasurementId.Video2InputState, 'Video2In State'],
        [Mri.WebApi.MeasurementId.Video2InputXRes, 'Video2In XRes'],
        [Mri.WebApi.MeasurementId.Video2InputYRes, 'Video2In YRes'],
        [Mri.WebApi.MeasurementId.Video2InputValidDuration, 'Video2In Valid'],
        [Mri.WebApi.MeasurementId.Video2InputInvalidDuration, 'Video2In Invalid'],
        [Mri.WebApi.MeasurementId.Video2InputStalledOnBlackDuration, 'Video2In Black'],
        [Mri.WebApi.MeasurementId.Video2InputStalledDuration, 'Video2In Stalled'],
        [Mri.WebApi.MeasurementId.Video2InputFullRangeDetected, 'Video2In FullRange'],
        [Mri.WebApi.MeasurementId.Video1OutputState, 'Video1 Out State'],
        [Mri.WebApi.MeasurementId.Video1TxState, 'Video1Tx State'],
        [Mri.WebApi.MeasurementId.Video1OutputXRes, 'Video1Out X'],
        [Mri.WebApi.MeasurementId.Video1OutputYRes, 'Video1Out Y'],
        [Mri.WebApi.MeasurementId.Video1OutputFramesPerSec, 'Video1Out FPS'],
        [Mri.WebApi.MeasurementId.Video1OutputPixelClock, 'Video1Out Pixel Clock'],
        [Mri.WebApi.MeasurementId.Video1OutputFullRangeDetected, 'Video1Out Full Range'],
        [Mri.WebApi.MeasurementId.Video2OutputFullRangeDetected, 'Video2Out Full Range'],
        [Mri.WebApi.MeasurementId.VideoRejuvenationModeActive, 'Video Rejuv Active'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan1, 'HDMI Link1'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan2, 'HDMI Link2'],
        [Mri.WebApi.MeasurementId.HdmiLinkQualityChan3, 'HDMI Link3'],
        [Mri.WebApi.MeasurementId.UrsaInputXRes, 'UrsaX'],
        [Mri.WebApi.MeasurementId.UrsaInputYRes, 'UrsaY'],
        [Mri.WebApi.MeasurementId.GeoVuSunrise, 'GeoVu Sunrise'],
        [Mri.WebApi.MeasurementId.GeoVuSunset, 'GeoVu Sunset'],
        [Mri.WebApi.MeasurementId.WxSunrise, 'Wx Sunrise'],
        [Mri.WebApi.MeasurementId.WxSunset, 'Wx Sunset'],
        [Mri.WebApi.MeasurementId.WxUtcOffset, 'Wx Utc Offset'],
        [Mri.WebApi.MeasurementId.CurrentTime, 'CurrentTime'],
        [Mri.WebApi.MeasurementId.Timezone, 'Timezone'],
        [Mri.WebApi.MeasurementId.InfiniteTouch1GlassType, 'IT1 Glass Type'],
        [Mri.WebApi.MeasurementId.InfiniteTouch2GlassType, 'IT2 Glass Type'],
        [Mri.WebApi.MeasurementId.InletUnitDailyMaxCurrent, 'Inlet Daily Max Current'],
        [Mri.WebApi.MeasurementId.InletUnitLifetimeMaxCurrent, 'Inlet Lifetime Max Current'],
    ]);

    public static TaskState = new Map<Mri.UserTasks.UserTaskState, string>([
        [Mri.UserTasks.UserTaskState.Idle, 'Idle'],
        [Mri.UserTasks.UserTaskState.Running, 'Running'],
        [Mri.UserTasks.UserTaskState.Completed, 'Completed'],
        [Mri.UserTasks.UserTaskState.Failed, 'Failed'],
    ]);

    public static PowerStatus = new Map<Mri.DisplaySettings.PowerStatus, string>([
        [Mri.DisplaySettings.PowerStatus.On, 'On'],
        [Mri.DisplaySettings.PowerStatus.Off, 'Off'],
        [Mri.DisplaySettings.PowerStatus.Reboot, 'Reboot'],
        [Mri.DisplaySettings.PowerStatus.PowerCycle, 'Power Cycle'],
    ]);

    public static ConnectedDevice = new Map<Mri.DisplayApi.ConnectedDevice, string>([
        [Mri.DisplayApi.ConnectedDevice.deviceModem, 'Modem'],
        [Mri.DisplayApi.ConnectedDevice.deviceRouter, 'Router'],
        [Mri.DisplayApi.ConnectedDevice.devicePlayer1, 'Player 1'],
        [Mri.DisplayApi.ConnectedDevice.devicePlayer2, 'Player 2'],
        [Mri.DisplayApi.ConnectedDevice.deviceVideoServerOrAccessPoint, 'Video Server Or Access Point'],
        [Mri.DisplayApi.ConnectedDevice.deviceM2M, 'M2M'],
        [Mri.DisplayApi.ConnectedDevice.device240Board, 'All Devices & Display'],
        [Mri.DisplayApi.ConnectedDevice.sigmaController1, 'InfiniteTouch® Controller 1'],
        [Mri.DisplayApi.ConnectedDevice.sigmaController2, 'InfiniteTouch® Controller 2'],
    ]);

    public static SerialNumberFormat = new Map<Mri.Parts.SerialNumberFormatEnum, string>([
        [Mri.Parts.SerialNumberFormatEnum.FreeForm, 'Freeform'],
        [Mri.Parts.SerialNumberFormatEnum.Regex, 'Regex'],
        [Mri.Parts.SerialNumberFormatEnum.MRI_Board_2_4, 'MRI 2_4'],
        [Mri.Parts.SerialNumberFormatEnum.MRI_Assembly_2_5, 'MRI 2_5'],
        [Mri.Parts.SerialNumberFormatEnum.CryotecCooler_13, 'Cryotec Cooler'],
    ]);

    public static RecipientType = new Map<Mri.DisplayAlerts.RecipientType, string>([
        [Mri.DisplayAlerts.RecipientType.Email, 'Email'],
        [Mri.DisplayAlerts.RecipientType.SMS, 'SMS'],
        [Mri.DisplayAlerts.RecipientType.Ticket, 'Zendesk Ticket'],
        [Mri.DisplayAlerts.RecipientType.UserId, 'User Alert'],
        [Mri.DisplayAlerts.RecipientType.Webhook, 'Webhook'],
        [Mri.DisplayAlerts.RecipientType.AccountSubscribers, 'Warranty Alert Account Subscribers'],
        [Mri.DisplayAlerts.RecipientType.WarrantyEmail, 'Warranty Email'],
        [Mri.DisplayAlerts.RecipientType.OutOfWarrantySubscribers, 'Out Of Warranty Email'],
    ]);

    public static ProjectStatus = new Map<Mri.ProductionProjects.ProjectStatus, string>([
        [Mri.ProductionProjects.ProjectStatus.Active, 'Active'],
        [Mri.ProductionProjects.ProjectStatus.Completed, 'Completed'],
        [Mri.ProductionProjects.ProjectStatus.Planning, 'Planning'],
        [Mri.ProductionProjects.ProjectStatus.ProductionPending, 'Production Pending'],
        [Mri.ProductionProjects.ProjectStatus.ToBeDeleted, 'To Be Deleted'],
    ]);

    public static PartState = new Map<Mri.PartStatus.PartState, string>([
        [Mri.PartStatus.PartState.Discarded, 'Discarded'],
        [Mri.PartStatus.PartState.InstalledInAssembly, 'Installed In Assembly'],
        [Mri.PartStatus.PartState.Inventory, 'Inventory'],
        [Mri.PartStatus.PartState.Maintenance, 'Maintenance'],
        [Mri.PartStatus.PartState.OutOfWarranty, 'Out Of Warranty'],
        [Mri.PartStatus.PartState.PickedToMO, 'Picked To MO'],
        [Mri.PartStatus.PartState.RMA, 'RMA'],
        [Mri.PartStatus.PartState.ShippedDisplay, 'Shipped Display'],
        [Mri.PartStatus.PartState.ToBeDeleted, 'To Be Deleted'],
        [Mri.PartStatus.PartState.Uninstalled, 'Uninstalled'],
        [Mri.PartStatus.PartState.Unknown, 'Unknown'],
        [Mri.PartStatus.PartState.Unpowered, 'Unpowered'],
        [Mri.PartStatus.PartState.Unsupported, 'Unsupported'],
        [Mri.PartStatus.PartState.Vandalized, 'Vandalized'],
    ]);

    public static VideoInputOutputState = new Map<number, string>([
        [0, 'Not Connected'],
        [1, 'Invalid Resolution'],
        [2, 'Valid Input, No Internal Sync'],
        [3, 'Valid Resolution'],
    ]);

    public static PowerGovernorSourceState = new Map<number, string>([
        [0, 'Too few Power Supplies'],
        [1, 'Too few fans'],
        [2, 'Too few fans CL'],
        [3, 'Too few fans HE'],
        [4, 'Too hot Closed Loop'],
        [5, 'Too hot backlight'],
        [6, 'Too hot system'],
        [7, 'Door Open'],
        [8, 'Door Open needs reset'],
        [9, 'Lost AC Power'],
        [10, 'High AC Inlet'],
        [11, 'Player not responding'],
        [12, 'Player shut down'],
        [13, 'TCON Reboot'],
        [14, 'Inlet Voltage Unknown'],
        [15, 'Inlet Voltage too low'],
        [16, 'Engine off'],
        [17, 'Low 48V Side 0'],
        [18, 'Low 48V Side 1'],
        [19, 'Power Supplies High'],
        [20, 'VTrim High'],
        [21, 'Server Boot'],
        [22, 'Standby Screen 0'],
        [23, 'Standby Screen 1'],
        [24, 'Video Source Change Screen 0'],
        [25, 'Video Source Change Screen 1'],
        [26, 'Nexus Comm Failed'],
        [27, 'Battery Test'],
        [28, 'URSA Comm Error'],
        [29, 'Solar Voltage Low'],
        [30, 'FPGA No Serial Comm'],
        [31, 'End of Disable Reasons'],
        [32, 'Reduction too few supplies'],
        [33, 'Reduction High AC Inlet'],
        [34, 'Reduction Backlight Warm'],
        [35, 'Reduction Closed Loop Warm'],
        [36, 'Reduction System Warm'],
        [37, 'Reduction Backlight Fan Failures'],
        [38, 'Reduction CL Fan Failures'],
        [39, 'Reduction HE Fan Failures'],
        [40, 'Reduction Door Open'],
        [41, 'Reduction Exceeded Max Load'],
        [42, 'Reduction DC Current'],
        [43, 'Reduction VTrim High'],
        [44, 'Reduction High DC Voltage'],
        [45, 'Reduction High DC Inlet Current'],
        [46, 'Reduction Low DC Inlet Voltage'],
        [47, 'Reduction Low AC Inlet Voltage'],
        [48, 'Reduction Low Solar Battery Voltage'],
        [49, 'Reduction Solar Power Conservation'],
        [50, 'Reduction Latch Side 1'],
        [51, 'Reduction Latch Side 2'],
        [52, 'Reduction Latch Side 1 Test Mode'],
        [53, 'Reduction Latch Side 2 Test Mode'],
        [54, 'No Source'],
    ]);

    public static CoolVuZone1ChartSource = new Map<number, string>([
        [0, 'Backlight 1'],
        [1, 'Backlight 2'],
        [2, 'PSU 1'],
        [3, 'PSU 2'],
        [4, 'PSU 3'],
        [5, 'PSU 4'],
        [6, 'Closed Loop 1'],
        [7, 'Cloased Loop 2'],
        [8, 'FPGA Die'],
        [9, 'Processor Board'],
        [10, 'Ambient'],
        [11, 'Ambient Exhaust'],
        [12, 'Local Weather'],
        [13, 'Humidity Temp'],
        [14, 'Infinite Touch 1'],
        [15, 'Infinite Touch 2'],
    ]);

    public static RXTXState = new Map<number, string>([
        [1, 'Idle'],
        [2, 'Ready'],
    ]);

    public static WeatherCodes = new Map<Mri.WebApi.MeasurementId.WeatherCode, string>([
        [200, 'ThunderStorm'],
        [201, 'ThunderStorm'],
        [202, 'ThunderStorm'],
        [210, 'ThunderStorm'],
        [211, 'ThunderStorm'],
        [212, 'ThunderStorm'],
        [221, 'ThunderStorm'],
        [230, 'ThunderStorm'],
        [231, 'ThunderStorm'],
        [232, 'ThunderStorm'],
        [300, 'Drizzle'],
        [301, 'Drizzle'],
        [302, 'Drizzle'],
        [310, 'Drizzle'],
        [311, 'Drizzle'],
        [312, 'Drizzle'],
        [313, 'Drizzle'],
        [314, 'Drizzle'],
        [321, 'Drizzle'],
        [500, 'Rain'],
        [501, 'Rain'],
        [502, 'Rain'],
        [503, 'Rain'],
        [504, 'Rain'],
        [511, 'Rain'],
        [520, 'Rain'],
        [521, 'Rain'],
        [522, 'Rain'],
        [531, 'Rain'],
        [600, 'Snow'],
        [601, 'Snow'],
        [602, 'Snow'],
        [611, 'Snow'],
        [612, 'Snow'],
        [613, 'Snow'],
        [615, 'Snow'],
        [616, 'Snow'],
        [620, 'Snow'],
        [621, 'Snow'],
        [622, 'Snow'],
        [701, 'Mist'],
        [711, 'Smoke'],
        [721, 'Haze'],
        [731, 'Dust'],
        [741, 'Fog'],
        [751, 'Sand'],
        [761, 'Dust'],
        [762, 'Ash'],
        [771, 'Squall'],
        [781, 'Tornado'],
        [800, 'Clear'],
        [801, 'Clouds'],
        [802, 'Clouds'],
        [803, 'Clouds'],
        [804, 'Clouds'],
    ]);

    public static WeatherCodeDescription = new Map<Mri.WebApi.MeasurementId.WeatherCode, string>([
        [200, 'Thunderstorm with light rain'],
        [201, 'Thunderstorm with rain'],
        [202, 'Thunderstorm with heavy rain'],
        [210, 'Light thunderstorm	'],
        [211, 'Thunderstorm'],
        [212, 'Heavy thunderstorm'],
        [221, 'Ragged thunderstorm'],
        [230, 'Thunderstorm with light drizzle'],
        [231, 'Thunderstorm with drizzle'],
        [232, 'Thunderstorm with heavy drizzle'],
        [300, 'Light intensity drizzle	'],
        [301, 'Drizzle'],
        [302, 'Heavy intensity drizzle'],
        [310, 'Light intensity drizzle rain'],
        [311, 'Drizzle rain'],
        [312, 'Heavy intensity drizzle rain'],
        [313, 'Shower rain and drizzle'],
        [314, 'Heavy shower rain and drizzle'],
        [321, 'Shower drizzle'],
        [500, 'Light rain'],
        [501, 'Moderate rain'],
        [502, 'Heavy intensity rain'],
        [503, 'Very heavy rain'],
        [504, 'Extreme rain'],
        [511, 'Freezing rain'],
        [520, 'Light intensity shower rain'],
        [521, 'Shower rain'],
        [522, 'Heavy intensity shower rain'],
        [531, 'Ragged shower rain'],
        [600, 'Light snow'],
        [601, 'Snow'],
        [602, 'Heavy snow'],
        [611, 'Sleet'],
        [612, 'Light shower sleet'],
        [613, 'Shower sleet'],
        [615, 'Light rain and snow'],
        [616, 'Rain and snow'],
        [620, 'Light shower snow'],
        [621, 'Shower snow'],
        [622, 'Heavy shower snow'],
        [701, 'Mist'],
        [711, 'Smoke'],
        [721, 'Haze'],
        [731, 'Sand/Dust whirls'],
        [741, 'Fog'],
        [751, 'Sand'],
        [761, 'Dust'],
        [762, 'Volcanic Ash'],
        [771, 'Squalls'],
        [781, 'Tornado'],
        [800, 'Clear Sky'],
        [801, 'Few clouds: 11-25%'],
        [802, 'Scattered clouds: 25-50%'],
        [803, 'Broken clouds: 51-84%'],
        [804, 'Overcast clouds: 85-100%'],
    ]);

    public static RoleInUnit = new Map<Mri.DisplayApi.RoleInUnit, string>([
        [0, 'Unknown'],
        [1, 'Single'],
        [2, 'Primary'],
        [3, 'Secondary'],
    ]);
}
